/*!
 * relax.js
 *
 * Copyright 2016, bibo
 * Released under the MIT license
 * http://opensource.org/licenses/MIT
 */

/**
 * 注意：
 *    1 $Data中的键名不能有'-'符号，这是因为RelaxMap里在value定位时使用了该符号。
 *    2 不要将Relax用于body以外的地方，并且Relax不支持frameset和frame。
 *    3 对于table相关的HTML TAG，开发者需要将其父子标签写全，以防止Relax计算的位置与浏览器渲染结果不同。
 *    4 不要在模板中使用<link>标签和<script></script>标签，这种标签里的语句不会执行，href或src引入也不行。
 *    5 好消息是，你可以在模板中使用<style></style>标签。
 *    6 模板中换行符及前后空格会被删掉，包括<pre></pre>中的。
 *    7 不要把语法标签和html标签错位混搭，比如{{#some}}<div>{{/some}}</div>。
 *    8 写TAG参数的时候务必遵循some="thing"的规范，不要写成some=thing或者some。对布尔类型的可以用checked="{{checked}}"，Relax会处理好这种类型。
 *    9 属性里使用监听只能是name="{{$value}}"，即value里只能有监听占位符。
 *   10 textarea统一使用value作为默认值的赋给以及值监听的获取，Relax会忽略它的innerHTML的部分。
 *   11 将自定义用于内部的方法声明时用_开头。
 *   12 稀疏数组，比如[1,2,undefined,4]，会当做子元素删除处理。这是因为DOM结构中不会出现稀疏子元素。
 *   13 数据中不能使用$thisKeyIsALoop$
 *   14 事件的名字是不区分大小写的，即onReady与onready是一样的。
 *   15 只有new Relax时传入的"onEvent"如onRender会被自动绑定，其他情况下若想绑定只能用on方法。
 *   16 如果不是通过Relax事件绑定方法绑定的回调，在执行完逻辑之后需要手动调一下$Change。
 *   17 同一个冒泡路径的事件回调里，任意一个使用了event.preventDefault()都会导致同路径其他元素的默认行为被取消。
 *   18 listener只能用在属性的值里
 */
(function(scope, Relax) {
    if (!scope.Relax) {
        scope.Relax = Relax();
    }
})(window, function() {
    'use strict';
    var CONSOLE,
        IGNOREBLANK,
        ID_ON_TAG = 'ri',
        EVENT_HEAD = 'on',
        SELF_METHOD = '_',
        ID_SPLITTER = ':',
        EVENT_ON_TAG = 'rx',
        ATTR_SPLITTER = 'AT',
        VALUE_SPLITTER = 'VA',
        LEVEL_SPLITTER = '-',
        TEXT_NODE = 'TEXT_NODE',
        INSERT = 'INSERT',
        DELETE = 'DELETE',
        LOOP_KEY = '$thisKeyIsALoop$',
        WRAPPED = '$wrapped$',
        CACHE_CALLED = 100,
        GRAMMAR_TAG = {
            START: '{{',
            END  : '}}'
        },
        GRAMMAR_TYPE = {
            VALUE        : '',
            LISTEN       : '$',//需要是1个字符
            LOOP         : '#',//需要是1个字符
            IF           : '?',//需要是1个字符
            IF_NOT       : '!',//需要是1个字符
            END          : '/',//需要是1个字符
            CURRENT_VALUE: '_VALUE_',//循环中的当前子级
            INDEX        : '_INDEX_',//循环的下标，从1开始
            _LOOP_CHILD_ : '_LOOP_CHILD_',//内部虚拟的循环子元素容器
            _LOOP_INSTS_ : '_LOOP_INSTS_' //内部虚拟的循环子元素容器
        },
        LOOP_SPLITTER = {
            START : '[',
            MIDDLE: '*',
            END   : ']',
            ALL   : undefined,
            test  : undefined
        },
        TYPE1 = {
            ATTR: 'ATTR',
            NODE: 'NODE'
        },
        TYPE2 = {
            ADD   : 'ADD',
            UPDATE: 'UPDATE',
            DELETE: 'DELETE'
        },
        TABLE_TAGS = {
            'caption' : 'table',
            'colgroup': 'table',
            'col'     : 'colgroup',
            'thead'   : 'table',
            'tfoot'   : 'table',
            'tbody'   : 'table',
            'tr'      : 'tbody',
            'th'      : 'tr',
            'td'      : 'tr'
        },
        BOOLEAN_ATTRS = [
            'hidden',
            'checked',
            'disabled',
            'multiple',
            'required',
            'selected'
        ],
        EVENTS_FOR_LISTENER = [//TODO 测试各种终端各种浏览器的各种表现
            'input',           //HTML5
            'compositionstart',//HTML5
            'compositionend',  //HTML5
            'DOMAutoComplete', //HTML5
            'keypress',        //字符按键按下时
            'change',          //失去焦点时
            'click',           //点击选择时
            'selectionchange', //IE6-8第一次修改
            'propertychange'   //IE6-8

        ],
        VACUUM = {};

    /**
     * Relax的构造函数。
     *
     * @param {Object} module
     */
    function Relax(module) {
        var self = this;

        self.welcome(module);

        self.analyse();

        self.beReady();
    }

    /**
     * 初始化module。
     *
     * @param {Object} module
     */
    Relax.prototype.welcome = function(module) {
        var self = this;

        self.config = {                 //配置
            debug   : false,            //是否开启调试模式
            startTag: GRAMMAR_TAG.START,//语法的开始标签
            endTag  : GRAMMAR_TAG.END,  //语法的结束标签
            cacheMax: 500               //缓存区的容量
        };

        self.system = {           //系统私有属性和方法
            logHead   : '',       //日志的开头
            console   : undefined,//输出日志
            nodeLength: 0,        //已记录元素的数量，用于生成唯一rxId
            hasListen : false,    //包含需要监听的属性
            dataWhite : {},       //需要监控的数据白名单
            events    : {},       //内部事件列表
            eventsDelegated: [],  //代理的时间列表
            toBind    : undefined,//等待绑定的事件
            rxToId    : {}        //事件ID到rxId的映射
        };

        //rxId的一些常用信息
        self.rxIdDetail = {};

        //提取模板
        if (kindOf(module.template) == '[object Function]') {
            module.template();
        }
        self.template = module.template
            .replace(/<!--.*?-->/g, "")
            .replace(/\s*^\s*/mg, "");

        //编译后的模板
        self.analysed = undefined;

        //数据与rxId的对应关系
        self.relaxMap = undefined;

        //初始化config
        if (kindOf(module.config) == '[object Object]') {
            self.config = merge(self.config, module.config);
        }

        //初始化console
        if (self.config.debug) {
            self.system.console = CONSOLE;
        } else {
            self.system.console = {
                info   : fNOP,
                log    : fNOP,
                time   : fNOP,
                timeEnd: fNOP,
                error  : fNOP
            };
        }

        //格式化module
        if (module.container === undefined) {
            self.system.console.error('Relax: what is your container?');
        } else {
            self.container = module.container.replace(/^#/, '');

            self.system.logHead = self.container + ':';

            self.system.toBind = [];

            each(Object.keys(module), function(key) {
                var keyTmp;

                if (key.substr(0, EVENT_HEAD.length) === EVENT_HEAD) {
                    keyTmp = key.substr(EVENT_HEAD.length);
                    if (keyTmp.toLowerCase() === 'Render'.toLowerCase()) {
                        self.on(keyTmp, module[key]);
                    } else {
                        self.system.toBind.push({
                            name: keyTmp,
                            handler: module[key]
                        });
                    }
                } else if (key.substr(0, SELF_METHOD.length) === SELF_METHOD) {
                    self[key] = module[key].bind(self);
                }
            });

            self.on('$Change', self.$Change);
        }
    };

    /**
     * 分析模板
     * 
     * 由于模板的输出结果是静态不变的，只和模板有关，并且relaxMap也只与模板有关，
     * 所以后面这步可以在代码打包的时候完成，但要处理好container ID的嵌入问题。
     */
    Relax.prototype.analyse = function() {
        var self = this,
            timeName = self.system.logHead + ' 模板编译耗时';

        self.system.console.time(timeName);

        self.structure = [];
        self.structure.end = -1;//用来代替.length，希望对提高性能有帮助

        self.system.grammarTagTest = new RegExp(self.config.startTag + '(.*?)' + self.config.endTag, 'g');

        collectTags(self.template);

        /**
         * RelaxTags：
         *
         * TEXT_NODE:
         * {
         *    tagName: 'TEXT_NODE',
         *    rxId: '',
         *    content: ''
         * }
         *
         * GRAMMAR_TAG:
         * {
         *    tagName: '',
         *    rxId: '',
         *    grammarType: '',
         *    [paired: true,]paired是true的时候不一定有children
         *    [children: []]有children的时候paired一定是true
         * }
         *
         * HTML_TAG:
         * {
         *    tagName: '',
         *    rxId: '',
         *    [attrs: {special: [], normal: []},]
         *    [paired: true,]paired是true的时候不一定有children
         *    [children: []]有children的时候paired一定是true
         * }
         *
         * ATTR_TAG外部:
         * attrs: {
         *    special: [
         *       {//这才是真正的ATTR_TAG
         *          name: 'class',
         *          rxId: '',
         *          value: [TEXT_NODE或GRAMMAR_TAG]
         *       }
         *    ],
         *    normal: ['some1="else1"', 'some2="else2"']
         * }
         */
        self.analysed = getStructure(self.structure, self.structure.length - 1);

        //断开对structure中对象的引用，希望能对减少内存占用有帮助。
        self.structure = [];
        delete self.structure;

        if (self.analysed === undefined) {
            self.system.console.error(self.system.logHead, 'Tag analyse failed.');
        } else {
            self.analysed = self.analysed.found;
        }

        self.initRelaxMap();

        self.initRelaxCache();

        self.getRxIdPaths(self.analysed, '', '');

        self.buildDataWhite();

        self.system.console.timeEnd(timeName);

        /**
         * 收集模板中的各种Tag
         *
         * @param {String} template
         */
        function collectTags(template) {
            var inner,
                last_offset = 0;

            template.replace(/<.*?>/g, function(match, offset) {
                if (offset > last_offset) {
                    forBetweenTag(template.slice(last_offset, offset), self.structure);
                }

                inner = match.match(/<\/?(\w+)\ *(.*?)\ *\/?>$/);

                if (!inner) {
                    self.system.console.error(self.system.logHead, 'Bad tag' +  match + '.');
                }

                self.structure.push({
                    tagName: inner[1].toLowerCase()
                });
                self.structure.end++;

                if (/<\/\w+/.test(match)) {
                    self.structure[self.structure.end].isEnd = true;
                } else if (inner[2] !== '') {
                    forAttr(inner[2]);
                }

                last_offset = offset + match.length;

                return match;
            });

            if (last_offset != template.length) {
                forBetweenTag(template.slice(last_offset), self.structure);
            }
        }

        /**
         * 从后到前分析html tag
         *
         * @param {Array} tags
         * @param {Number} pointer
         * @param {Object} [pair]
         *
         * 思路：
         * 倒序分析tags————循环A，如果到头了就退出
         *    如果不是end
         *       如果有待配对tag且tagName相同
         *          与待配对的tag配上了，放到close_tag标记里
         *          退出循环A
         *       否则
         *          这是一个非闭合性的tag或TEXT_NODE，放到记录数组里
         *          进入下一轮循环A
         *    否则
         *       从前一个tag开始，寻找它的待配对tag
         *       如果子任务的返回没有close_tag
         *          tag没有闭合，抛出错误
         *          中止
         *       整理返回结果
         *       同步pointer
         *       进入下一轮循环A
         *
         * 返回记录数组
         */
        function getStructure(tags, pointer, pair) {
            var re = {
                    found: []
                }, tmp;

            for (var i = pointer; i >= 0; i--) {
                if (!tags[i].isEnd) {
                    if (
                        //如果pair是语法，属于GRAMMAR_TAG配对的情况，那么tags[i]也应该是语法，且是语法的开始
                        pair != undefined &&
                        pair.grammarType !== undefined &&
                        tags[i].grammarType !== undefined &&
                        isGrammerStart(tags[i].grammarType) &&
                        tags[i].tagName == pair.tagName ||
                        //否则，属于HTML_TAG配对的情况，那么tags[i]不应该是语法
                        pair != undefined &&
                        pair.grammarType === undefined &&
                        tags[i].grammarType === undefined &&
                        tags[i].tagName == pair.tagName
                    ) {
                        re.close_tag = tags[i];
                        re.latest_pointer = i;
                        break;
                    } else if (tags[i].tagName === TEXT_NODE) {
                        isText(re.found, tags[i]);
                    } else {
                        isTag(re.found, tags[i]);
                    }
                } else {
                    tmp = getStructure(tags, i - 1, tags[i]);
                    if (!tmp) {
                        self.system.console.error(
                            self.system.logHead,
                            tags[i - 1].tagName + ' does not have correspond start tag.'
                        );
                        return;
                    }
                    if (!tmp.close_tag) {
                        self.system.console.error(
                            self.system.logHead,
                            tags[i].tagName + ' does not have correspond start tag.'
                        );
                        return;
                    }
                    tmp.close_tag.paired = true;
                    i = tmp.latest_pointer;
                    if (tmp.found.length != 0) {
                        tmp.close_tag.children = tmp.found;
                    }
                    isTag(re.found, tmp.close_tag);
                }
            }

            /**
             * 普通情况下，for循环后i会比实际情况小1，这是因为for循环会先改变i再对i>=0做判断。
             * 但是，如果是break的情况，i就是实际情况，所以这里要对i做区分处理。
             */
            if (re.latest_pointer === undefined) {
                re.latest_pointer = i + 1;
            }

            return re;
        }

        function isGrammerStart(type) {
            return [GRAMMAR_TYPE.LOOP, GRAMMAR_TYPE.IF, GRAMMAR_TYPE.IF_NOT].indexOf(type) != -1;
        }

        function forAttr(attrString) {
            var attrs;

            //严谨起见，避免出现多个空格的情况
            attrString = attrString.replace(/\ (?=\ )/g, '');

            attrs = attrString.match(/[^\ ]+=('.*?'|".*?")|[^\ ]+/g);//注意，属性里可能有引号

            if (attrs) {
                self.structure[self.structure.end].attrs = {};
            }

            //处理每一个属性
            each(attrs, function(attr) {
                var name,
                    value,
                    tmp,
                    to_push;

                attr = attr.split('=');

                attr = [attr[0], attr.slice(1).join('=')];//属性里可能有等号

                name = attr[0];

                if (name.indexOf(GRAMMAR_TAG.START) != -1) {
                    self.system.console.error(
                        self.system.logHead,
                        'Don\'t write like this ' + name + ', write attribute="value or {{tag}}" instead.'
                    );
                }

                if (attr[1] !== undefined) {
                    value = attr[1];
                    if (value[0] !== '"' && value[0] !== "'") {
                        self.system.console.error(
                            self.system.logHead,
                            'Don\'t write like this ' + attr.join('=') + ', write',
                            name + '=' + '"' + value + '"',
                            'instead.'
                        );
                    }
                    value = value.slice(1, -1);
                }

                if (kindOf(name) === '[object Number]') {
                    self.system.console.error(
                        self.system.logHead,
                        'Tag\'s attribute name can not be number.'
                    );
                    return;
                }

                if (name === EVENT_ON_TAG) {
                    if (!value) {
                        self.system.console.error(
                            self.system.logHead,
                            'The value of ' + EVENT_ON_TAG + ' can\'t be blank.'
                        );
                        return;
                    } else if (self.system.grammarTagTest.test(value)) {
                        self.system.console.error(
                            self.system.logHead,
                            'The value of ' + EVENT_ON_TAG + ' can\'t include grammar.'
                        );
                        return;
                    }
                }

                if (value) {
                    self.system.grammarTagTest.lastIndex = 0;
                    if (self.system.grammarTagTest.test(value)) {
                        //值里有占位符
                        tmp = [];

                        forBetweenTag(value, tmp, true);

                        if (
                            new RegExp(self.config.startTag + '\\' + GRAMMAR_TYPE.LISTEN).test(value) &&
                            tmp.length > 1
                            ) {
                            self.system.console.error(
                                self.system.logHead,
                                'If you want to listen attribute\'s value, just use name="{{$value}}", not',
                                attr.join('='),
                                '.'
                            );
                            return;
                        }

                        to_push = {
                            name: name,
                            value: tmp
                        };

                        if (!self.structure[self.structure.end].attrs.special) {
                            self.structure[self.structure.end].attrs.special = [];
                        }
                        self.structure[self.structure.end].attrs.special.push(to_push);
                    } else {
                        //值里没有占位符
                        if (!self.structure[self.structure.end].attrs.normal) {
                            self.structure[self.structure.end].attrs.normal = [];
                        }
                        self.structure[self.structure.end].attrs.normal.push([
                            name, '=', '"', value, '"'
                        ].join(''));
                    }
                } else {
                    //只有name没有value的情况
                    if (!self.structure[self.structure.end].attrs.normal) {
                        self.structure[self.structure.end].attrs.normal = [];
                    }
                    self.structure[self.structure.end].attrs.normal.push(name);
                }
            });
        }

        /**
         * 处理betweenTag，即tag之间的部分
         *
         * @param {String} str
         * @param {Object} target
         * @param {Boolean} [inValue]
         */
        function forBetweenTag(str, target, inValue) {
            var last_offset = 0;

            if (kindOf(target.end) !== '[object Number]') {
                target.end = -1;
            }

            self.system.grammarTagTest.lastIndex = 0;
            str.replace(self.system.grammarTagTest, function(match, p1, offset) {
                if (offset > last_offset) {
                    addTextNode(target, str.slice(last_offset, offset));
                }

                switch(p1.charAt(0)) {
                    case GRAMMAR_TYPE.LISTEN:
                        if (inValue) {
                            self.system.hasListen = true;
                            target.push({
                                tagName: p1.substr(1),
                                grammarType: GRAMMAR_TYPE.LISTEN
                            });
                        } else {
                            self.system.console.error(
                                self.system.logHead,
                                'Listener is only allowed in attribute, not in other places like',
                                p1,
                                '.'
                            );
                        }
                        break;
                    case GRAMMAR_TYPE.LOOP:
                        target.push({
                            tagName: p1.substr(1),
                            grammarType: GRAMMAR_TYPE.LOOP
                        });
                        break;
                    case GRAMMAR_TYPE.IF:
                        target.push({
                            tagName: p1.substr(1),
                            grammarType: GRAMMAR_TYPE.IF
                        });
                        break;
                    case GRAMMAR_TYPE.IF_NOT:
                        target.push({
                            tagName: p1.substr(1),
                            grammarType: GRAMMAR_TYPE.IF_NOT
                        });
                        break;
                    case GRAMMAR_TYPE.END:
                        target.push({
                            tagName: p1.substr(1),
                            grammarType: GRAMMAR_TYPE.END,
                            isEnd: true
                        });
                        break;
                    default:
                        if (p1 === GRAMMAR_TYPE.CURRENT_VALUE) {
                            target.push({
                                tagName: p1,
                                grammarType: GRAMMAR_TYPE.CURRENT_VALUE
                            });
                        } else if (p1 === GRAMMAR_TYPE.INDEX) {
                            target.push({
                                tagName: p1,
                                grammarType: GRAMMAR_TYPE.INDEX
                            });
                        } else {
                            target.push({
                                tagName: p1,
                                grammarType: GRAMMAR_TYPE.VALUE
                            });
                        }
                }

                target.end++;

                if (target[target.end].tagName === '') {
                    self.system.console.error(
                        self.system.logHead,
                        'You\'ve used an bad tag like this ' + match + '.'
                    );
                }

                last_offset = offset + match.length;

                return match;
            });

            if (last_offset != str.length) {
                addTextNode(target, str.slice(last_offset));
            }
        }

        function addTextNode(target, text) {
            target.push({
                tagName: TEXT_NODE,
                content: text
            });
            target.end++;
        }

        /**
         * 处理一个tag
         *
         * @param {Array} array
         * @param {Object} one
         */
        function isTag(array, one) {
            var tmp;

            /**
             * 如果是textarea需要特殊处理，将它的innerHTML清空，把value当作"innerHTML"。
             * 这是因为，textarea第一次显示时会将innerHTML当作value显示出来，但后期修改或是
             * 获取value时只能通过node.value的方式。这里，把value放到innerHTML的位置后，如果
             * 数据变了，那么Relax会同时修改属性中的value和innerHTML部分，这样与input的处理
             * 方式就可以统一。
             */
            if (one.tagName === 'textarea' && one.children) {
                if (one.attrs && one.attrs.special) {
                    for (var i = 0, maxi = one.attrs.special.length; i < maxi; i++) {
                        if (one.attrs.special[i].name == 'value') {
                            each(one.attrs.special[i].value, function(v) {
                                if (!one.children) {
                                    one.children = [];
                                }
                                one.children.push(clone(v));
                            });

                            tmp = getStructure(one.children, one.children.length - 1);

                            if (tmp.latest_pointer !== 0) {
                                self.system.console.error(self.system.logHead, 'Textarea analyse failed.');
                                return;
                            }

                            one.children = tmp.found;
                            break;
                        }
                    }
                }
            }

            //给属性增加rxId
            if (one.attrs && one.attrs.special) {
                each(one.attrs.special, function(attr) {
                    delete attr.value.end;

                    attr.value = getStructure(attr.value, attr.value.length - 1);

                    if (attr.value.latest_pointer !== 0) {
                        self.system.console.error(self.system.logHead, 'Attribute analyse failed.');
                        return;
                    }

                    attr.value = attr.value.found;

                    attr.rxId = self.generateRxId();
                });
            }

            if (one.grammarType === GRAMMAR_TYPE.LOOP && one.children && one.children.length) {
                //这里处理到的都不会是属性上的部分，并且到这里时，children已经处理完
                //给循环的子元素外面套上一层，以方便后面追踪循环生成的子元素
                one.children = [{
                    children: one.children,
                    grammarType: GRAMMAR_TYPE._LOOP_CHILD_,
                    paired: true,
                    tagName: one.tagName,
                    rxId: self.generateRxId()
                }];
            }

            common(array, one);
        }

        /**
         * 处理一个TEXT_NODE
         *
         * @param {Array} array
         * @param {Object} one
         */
        function isText(array, one) {
            common(array, one);
        }

        /**
         * 对tag和TEXT_NODE的相同处理
         *
         * @param {Array} array
         * @param {Object} one
         */
        function common(array, one) {
            one.rxId = self.generateRxId();
            array.unshift(one);
        }
    };

    /**
     * Relax实例准备完毕
     */
    Relax.prototype.beReady = function() {
        var self = this,
            changeNow = true;

        Relax.modules[self.container] = self;

        self.system.console.info(self.system.logHead, 'Relaxed.');

        /**
         * 关于事件
         *    一般事件就用 事件名: [handler1, handler2, ...]
         *    如果是rx标记的，则'事件名:rx标记': []
         *
         * 关于触发事件
         *    如果是DOM事件
         *       如果该DOM上有listener
         *          更新对应listener的值
         *    如果事件名对应的handler不存在
         *       如果对应的on...方法存在
         *          绑定方法
         *          绑定Data包装
         *          触发此事件
         *    否则
         *       依次运行handler.apply(this, [如果有参数的话，放上参数])
         *
         * 关于绑定事件
         *    在handler里添加此回调
         *
         * 关于移除事件
         *    指定事件名和handler
         *       如果存在此事件名
         *          递归handler，如果就是指定的handler则从数组中移除
         *          如果数组是空了则删除事件名
         *
         * 关于发异步请求
         *    如果还没有绑定
         *       绑定事件
         *       绑定Data包装
         *       标记已经绑定过了
         *    如果已经有缓存
         *       触发事件，传入缓存
         *       如果缓存是空了
         *          删除缓存数组本身
         *
         * 关于设置异步缓存
         *    设置：约定id，然后数据
         */

        /**
         * 准备出关心键值的白名单
         * 按照白名单给$Data绑定setter，setter的工作就是，将此键值放到变化数组里
         *    从根部往下扫，对象用in的方式，数组用循环的方式，除此之外则就到本身
         *       如果已绑定则往下走
         *       否则
         *          如果在白名单里
         *              如果白名单里有它的子键
         *                 如果子键还不存在
         *                    加上子键的占位符
         *                 如果有除白名单外的子键
         *                    删除这些子键
         *              标记已绑定
         *              绑定setter(这一步完成后，除非此键指向新的对象，否则是不允许增加其他子键的)
         */

        self.fire('Render');

        if (!document.getElementById(self.container)) {
            //如果此时能获取到容器元素就此时$Change，否则就domReady时$Change
            changeNow = false;
        }

        if (changeNow) {
            startChange();
        }

        domReady(function() {
            var toBind;

            if (!changeNow) {
                startChange();
            }

            while(self.system.toBind.length) {
                toBind = self.system.toBind.shift();
                self.on(toBind.name, toBind.handler);
            }

            toBind = null;

            delete self.system.toBind;

            if (self.system.hasListen) {
                for (var i = 0, maxi = EVENTS_FOR_LISTENER.length; i < maxi; i++) {
                    self.addEventDelegate(EVENTS_FOR_LISTENER[i]);
                }
            }

            self.fire('Ready');
        });

        function startChange() {
            //第一次调用Change
            self.turboOnce();
            self.fire('$Change', ['']);
        }
    };

    /**
     * Relax的事件代理handler
     *
     * @param {Object} event
     */
    Relax.prototype.eventDelegater = function(event) {
        var self = this,
            target = event.target || event.srcElement,
            eventName = event.type.toLowerCase(),
            path,
            bubble;

        if (target === document) {
            self.fire(eventName + ID_SPLITTER + 'document', event);
        } else {
            path = parents(target);

            if (path.length) {
                each(self.system.rxToId[path[0]], function(rxId) {
                    checkListener(rxId, target);
                });

                while(bubble = path.shift()) {
                    self.fire(eventName + ID_SPLITTER + bubble, event);
                    if (event.cancelBubble) {
                        break;
                    }
                }
            }
        }
        
        self.fire('$Change');

        /**
         * 检查属性中的listener
         */
        function checkListener(rxId, target) {
            var obj = self.getTheAnaObj(rxId),
                value,
                newValue,
                dataObj;

            if (obj.attrs && obj.attrs.special && obj.attrs.special.length) {
                for (var i = 0, maxi = obj.attrs.special.length; i < maxi; i++) {
                    value = self.relaxMap.getValueByRxId(obj.attrs.special[i].rxId);

                    //监听只能用在属性里且这种情况下属性里只能有监听
                    if (value.length && value[0].listen) {
                        value = value[0].value;

                        newValue = target[obj.attrs.special[i].name];

                        if (newValue === undefined) {
                            newValue = target.getAttribute(obj.attrs.special[i].name);
                        }

                        newValue = newValue === null ? undefined : newValue;

                        dataObj = self.getValueByPath(value);

                        value = value.split(LEVEL_SPLITTER).slice(-1)[0];

                        if (dataObj[value] !== newValue) {
                            dataObj[value] = newValue;
                        }
                    }
                }
            }
        }

        function parents(target) {
            var list = [];

            //target应该是document和container子级的其中一种
            while(target && target !== document) {
                var eventId;

                if (target.id && target.id === self.container) {
                    break;
                } else {
                    eventId = target.getAttribute(EVENT_ON_TAG);
                    if (eventId) {
                        list.push(eventId);
                    }
                    target = target.parentNode;
                }
            }

            return list;
        }
    };

    /**
     * Relax的添加事件代理方法
     *
     * @param {String} eventName
     * @param {String} [elementName]
     */
    Relax.prototype.addEventDelegate = function(eventName, elementName) {
        var self = this;

        if (self.system.eventsDelegated.indexOf(eventName) === -1) {
            addListener(
                self.container,
                elementName === 'document' ? document : document.getElementById(self.container),
                eventName,
                self.eventDelegater
            );
            self.system.eventsDelegated.push(eventName);
        }
    };

    /**
     * Relax的删除事件代理方法
     *
     * @param {String} eventName
     * @param {String} elementName
     */
    Relax.prototype.removeEventDelegate = function(eventName, elementName) {
        var self = this,
            index = self.system.eventsDelegated.indexOf(eventName);

        if (index != -1) {
            removeListener(
                self.container,
                elementName === 'document' ? document : document.getElementById(self.container),
                eventName,
                self.eventDelegater
            );
            self.system.eventsDelegated.splice(index, 1);
        }
    };

    /**
     * Relax内部事件绑定
     *
     * @param {String} name
     * @param {Function} handler
     */
    Relax.prototype.on = function(name, handler) {
        var self = this,
            originalName = name,
            eventName;

        name = normalizeEventName(name);

        eventName = name.split(ID_SPLITTER);

        if (eventName.length > 1) {
            self.addEventDelegate(eventName[0], eventName[1]);
        }

        if (!self.system.events[name]) {
            self.system.events[name] = [];
        }

        self.system.events[name].push(handler);
    };

    /**
     * Relax内部事件解绑
     *
     * @param {String} name
     * @param {Function} handler
     */
    Relax.prototype.off = function(name, handler) {
        var self = this,
            handlers,
            eventName;

        name = normalizeEventName(name);

        if (self.system.events[name]) {
            handlers = self.system.events[name];
            for (var i = 0, maxi = handlers.length; i < maxi; i++) {
                if (handlers[i] == handler) {
                    handlers.splice(i, 1);
                    i--;
                    maxi--;
                }
            }
            if (!handlers.length) {
                delete self.system.events[name];

                eventName = name.split(ID_SPLITTER);

                if (eventName.length > 1) {
                    self.removeEventDelegate(eventName[0], eventName[1]);
                }
            }
        }
    };

    /**
     * Relax内部事件触发
     * 可以指定传入的参数
     *
     * @param {String} name
     * @param {...}
     */
    Relax.prototype.fire = function(name) {
        var self = this;

        name = normalizeEventName(name);

        if (self.system.events[name]) {
            for (var i = 0, maxi = self.system.events[name].length; i < maxi; i++) {
                try {
                    self.system.events[name][i].apply(self, Array.prototype.slice.call(arguments, 1));
                } catch (e) {
                    self.system.console.error(self.system.logHead, e);
                }
            }
        }
    };

    /**
     * Relax内部对$Data的包装
     */
    Relax.prototype.dataWrapper = function(start) {
        var self = this;

        if (start === undefined) {
            start = self.$Data;

            if (!wrapped(start)) {
                wrapObj(start);
                //变化列表放入''
            }
        }

        switch(kindOf(start)) {
            case '[object Object]':
                for (var key in start) {
                    if (isOwnProp(start, key)) {
                        //白名单的作用self.system.dataWhite
                        wrapObj(start, key);
                        self.dataWrapper(start[key]);
                    }
                }
                break;
            case '[object Array]':
                wrapArray(start);
                for (var i = 0, maxi = start.length; i < maxi; i++) {
                    self.dataWrapper(start[i]);
                }
                break;
        }

        function wrapObj() {

        }

        function wrapArray() {

        }

        function wrapped(obj) {
            return !!obj[WRAPPED];
        }
    };

    /**
     * 处理完本次任务后需要继续执行的任务队列
     */
    Relax.prototype.nextTick = [];

    /**
     * 提升浏览器渲染的优先性
     */
    Relax.prototype.turboOnce = function() {
        var self = this;

        self.$Change.highPriority = true;
    };

    /**
     * Relax的数据改变
     *
     * @param {Array} changed 用于直接指定改变的value
     */
    Relax.prototype.$Change = function(changed) {
        var self = this,
            related,
            domJobs,
            reRoute;

        changed = getChanged(changed);
        
        if (!changed.length) {
            return;    
        }

        related = getRelated(changed);

        related = gatherTags(related);

        domJobs = renderTags(related);

        cleanData(changed);

        mergeJobs(domJobs);

        exeResult(domJobs);

        /**
         * 汇总数据的改变
         *
         * @param {Array} array
         */
        function getChanged(array) {
            var re = [];
            
            if (array === undefined) {
                /**
                 * TODO
                 * 通过递归对比$Data或者在$Data上设置setter来获取changed的变量
                 * 对于非对象非数组的，如果新值和旧值一样则过滤掉
                 * 如果直接改变了数组，则将数组中的undefined删掉
                 * 把通过下标将子元素设置成undefined视作删除子元素行为，标记删除但保留undefined
                 * 把通过pop、shift、splice删除的，标记删除，在对应位置加上undefined
                 * 数组插入或删除后，将后面子元素的_INDEX_更新
                 * 
                 * 收集数据的变化re.push(...)
                 * 如果变了
                 *    包装数据self.dataWrapper()
                 */
            } else {
                re = array;
            }

            return re;
        }

        /**
         * 获取相关的rxId
         *
         * @param {Array} array
         */
        function getRelated(array) {
            var related = [];

            if (array.length == 1 && array[0] == '') {
                //初始化的情况
                related = [''];
            } else {
                each(array, function(value) {
                    pushRxId(related, value);
                });
            }

            return related;
        }

        /**
         * 添加新增加的数组子元素
         * 注意，array如果有多个，他们的父级必须一样
         */
        function addInsts(array, insert) {
            var father,
                fatherValue,
                tail;

            father = toFather(array[0]);
            fatherValue = self.relaxMap.getValueByRxId(father)[0].value;
            father = self.getTheAnaObj(father);

            if (insert) {
                tail = splitLoop(array[0]);
                father.children.splice(tail[1], 0, {
                    rxId: array[0],
                    grammarType: GRAMMAR_TYPE._LOOP_INSTS_,
                    children: tailRxId(
                        clone(father.children[0].children),
                        LOOP_SPLITTER.START + tail[1] + LOOP_SPLITTER.END
                    )
                });

                self.getRxIdPaths(//只是为了在rxIdDetail和relaxMap中增加
                    [father.children[tail[1]]],
                    self.rxIdDetail[father.rxId].path,
                    fatherValue + LOOP_SPLITTER.START + tail[1] + LOOP_SPLITTER.END,
                    true
                );
            } else {
                for (var i = 0, maxi = array.length; i < maxi; i++) {
                    tail = LOOP_SPLITTER.START + father.children.length + LOOP_SPLITTER.END;
                    //在analysed中增加
                    father.children.push({
                        rxId: array[i],
                        grammarType: GRAMMAR_TYPE._LOOP_INSTS_,
                        children: tailRxId(
                            clone(father.children[0].children),
                            tail
                        )
                    });

                    self.getRxIdPaths(//只是为了在rxIdDetail和relaxMap中增加
                        father.children.slice(-1),
                        self.rxIdDetail[father.rxId].path,
                        fatherValue + tail,
                        true
                    );
                }
            }

            father = null;
        }

        /**
         * 将需要改变的rxId进行收敛，最后转换成obj
         *
         * 首先，关于DOM调用和重绘，哪个更耗时
         * 实际测试：
         * 方案1 一次DOM调用，50000个DOM的重绘
         *    准备：页面预先生成<div id="target"></div>
         *    开始Timeline记录
         *    (function() {
         *       document.getElementById('target').innerHTML = '<div>div</div>'.repeat(50000);
         *    })()
         *    58.29ms的HTML解析和374.59ms的重绘，45.42ms的JS运行。
         * 方案2 50000次DOM调用，1个DOM的重绘
         *    准备：在1的基础上进行
         *    开始Timeline记录
         *    (function() {
         *       var a = [];
         *       for (var i = 0, maxi = 50000 - 1; i < maxi; i++) {
         *          a.push(document.getElementById('target').childNodes[i].innerHTML);
         *       }
         *       var b = document.createElement('div');
         *       b.innerHTML = 'div';
         *       document.getElementById('target').parentNode.appendChild(b);
         *    })()
         *    0.03ms的HTML解析和1.80ms的重绘，125.31ms的JS运行。
         *
         * 两个方案对比得出，在DOM调用可以集中的情况下，重绘比单纯的DOM调用更耗时。
         * 由于实际情况中，DOM调用往往会导致重绘，那么务必要将可能导致的重绘降到最低。
         *
         * (1) 是否需要将多个子级改变的情况收敛到一次性改变父级：
         *     对于ATTR，由于setAttribute一次只能改变一个属性，所以不存在集中操作的可能，只可能一次
         *     性将NODE本身全部replace。但考虑到NODE会有子元素，最重要的是，改变属性如果会引起重绘的
         *     话，那么replace NODE会引起的重绘将更多。所以，ATTR不适合收敛。
         *     对于NODE首先分两4种情况：
         *     A 已生成NODE很少，准备生成的NODE很少
         *     B 已生成NODE很少，准备生成的NODE很多
         *     C 已生成NODE很多，准备生成的NODE很少
         *     D 已生成NODE很多，准备生成的NODE很多
         *     对于A和C，不适合做收敛。
         *     对于B和D，适合做收敛，但对于这种情况还可以细分：
         *     1 准备生成的NODE相邻。这种情况可以把准备生成的NODE集中，用一次DOM调用加入到界面中，所以
         *       不应该收敛。
         *     2 准备生成的NODE分散在已生成NODE周围，这种情况下，由于准备生成的很多，会导致多次DOM的
         *       调用，从减少DOM调用的角度考虑，应该进行收敛。但如果是情况D的话，DOM调用减少了，重绘的
         *       任务量却增加了很多。所以，只有情况B是适合收敛的。但对于B，既然已生成的NODE很少，必然
         *       准备生成的NODE很多都是相邻的，所以仍然不应该收敛。
         *     结论：不需要进行收敛，只需要在最后处理准备生成的NODE时，将相邻的NODE通过一次DOM调用处理。
         *     另一方面，根据DOM调用和重绘耗时的测试结果，应避免已生成NODE的重绘，因此，不应该收敛。
         * (2) 是否要将父级改变且子级也改变的情况下，收敛到父级：
         *     如果父级之前没有生成，那么必须收敛。否则，由于可能已经存在生成的子级，并且父级本身改变的
         *     可能是属性，所以不收敛。
         *     同时，如果父级未生成，子级却需要计算的，本来就应该将这个子级忽略。
         *
         * @param {Array} tags
         */
        function gatherTags(tags) {
            var re = [];

            //去重
            each(tags, function(one) {
                if (!hasThis(re, one)) {
                    re.push(one);
                }
            });

            if (re.indexOf('') !== -1) {
                re = [];
                each(self.analysed, function(one) {
                    re.push(one.rxId);
                });
            }

            //rxId从大到小
            re = re.sort(function(i, j) {
                return parseInt(i.split(':')[1]) < parseInt(j.split(':')[1]);
            });

            /**
             * 如果子级的父级未生成，则子级不需要在re里，这样
             * 同时也是对父级和子级都未生成但都需要改变的情况的收敛。
             * 如果子级的父级已经在计算队列了，那么子级不用再重复计算。
             *
             * 注意，这里的顺序是倒序的按rxId从小到大循环，即按照从下到上，从右到左，从子级到父级的顺序
             */
            for (var i = re.length - 1; i >= 0; i--) {
                if (!generated(toFather(re[i]))) {
                    if (re[i].slice(-1) == LOOP_SPLITTER.END) {
                        //数组父元素没生成时先生成父元素
                        if (fatherIn(re, re[i])) {
                            re.splice(i, 1);
                        } else {
                            re.splice(i, 1, toFather(re[i]));
                        }
                    } else {
                        re.splice(i, 1);
                    }
                } else if (fatherIn(re, re[i])) {
                    re.splice(i, 1);
                }
            }

            each(re, function(one, i) {
                re[i] = self.getTheAnaObj(one);
            });

            return re;
        }

        /**
         * 渲染RelaxTag，更新Map，返回需要执行的DOM操作
         * 顺序：从上到下，从外到内
         *
         * @param {Array} tagArray
         * @param {Boolean} [needDomPath]
         */
        function renderTags(tagArray, needDomPath) {
            var re = [];

            if (needDomPath === undefined) {
                needDomPath = true;
            }

            for (var i = 0, maxi = tagArray.length; i < maxi; i++) {
                if (tagArray[i].name) {
                    //如果是ATTR
                    processATTR(re, tagArray[i], needDomPath);
                } else if (tagArray[i].tagName === TEXT_NODE) {
                    //如果是TEXT_NODE
                    processTEXT_NODE(re, tagArray[i], needDomPath);
                } else if (tagArray[i].grammarType === GRAMMAR_TYPE._LOOP_CHILD_) {
                    //如果是_LOOP_CHILD_，由于这是个特殊的虚拟TAG，所以特殊处理下
                    processLOOP_CHILD(re, tagArray[i], needDomPath);
                } else if (
                    tagArray[i].grammarType === GRAMMAR_TYPE.VALUE ||
                    tagArray[i].grammarType === GRAMMAR_TYPE.LISTEN ||
                    tagArray[i].grammarType === GRAMMAR_TYPE.CURRENT_VALUE ||
                    tagArray[i].grammarType === GRAMMAR_TYPE.INDEX
                ) {
                    //如果是普通GRAMMER_TAG
                    processGRAM_Basic(re, tagArray[i], needDomPath);
                } else if (tagArray[i].grammarType !== undefined) {
                    //如果是GRAMMAR_TAG Block
                    processGRAM_Block(re, tagArray[i], needDomPath);
                } else {
                    //如果是HTML_TAG
                    processHTML_TAG(re, tagArray[i], needDomPath);
                }
            }

            return re;
        }

        /**
         * 获取相关的value，其实是找到此value所在的对象
         */
        function getValue(obj) {
            var re,
                valuePath,
                isChild = false;

            //rxId与value是多对一的关系
            if (obj.grammarType === GRAMMAR_TYPE._LOOP_CHILD_) {
                isChild = true;
                obj = toFather(obj.rxId);
                obj = self.getTheAnaObj(obj);
            }

            valuePath = self.relaxMap.getValueByRxId(obj.rxId)[0].value;

            if (reRoute && reRoute[valuePath]) {
                valuePath = reRoute[valuePath];
            }

            re = self.getValueByPath(valuePath);

            if (isChild) {
                if (obj.tagName != GRAMMAR_TYPE.CURRENT_VALUE) {
                    re = re[obj.tagName];
                }
            }

            return re;
        }

        /**
         * 获取相关的index
         *
         * @param {Object} obj
         */
        function getIndex(obj) {
            var father,
                re;

            //如果本身是数组元素，则返回数组的下标
            //否则，返回父级的index
            if (obj.grammarType == GRAMMAR_TYPE._LOOP_INSTS_) {
                re = splitLoop(obj.rxId)[1]
            } else {
                father = toFather(obj.rxId);
                while(
                    father != '' &&
                    (father = self.getTheAnaObj(father)).grammarType != GRAMMAR_TYPE._LOOP_INSTS_
                ) {
                    father = toFather(father.rxId);
                }
                if (father == '') {
                    re = 0;
                } else {
                    re = splitLoop(father.rxId)[1];
                }
                father = null;
            }

            return re;
        }

        /**
         * 执行RelaxTag的渲染结果
         *
         * @param {Array} jobs
         */
        function exeResult(jobs) {
            var headPointer = 0,
                highPriority = false;

            if (self.$Change.highPriority) {
                highPriority = true;
                self.$Change.highPriority = false;
            }
            /**
             * jobs = [{
             *  type1: ATTR|NODE,
             *  type2: 'ADD'|'UPDATE'|'DELETE',
             *  deleteRange: 2,
             *  domPath: [0, 1, 2],
             *
             *  html: '',
             *  children: []
             *  或
             *  name: '',
             *  value: ''
             * }]
             *
             * 如果type1是NODE
             *    如果type2是UPDATE
             *       把domPath对应的元素替换成此html
             *    否则，如果type2是ADD
             *       在此domPath的上一个NODE后插入，如果不存在就用父级的innerHTML操作
             *       html
             *    否则
             *       删除这个NODE
             * 如果type1是ATTR
             *    如果type2是ADD
             *       在此domPath的NODE上增加参数
             *       name value
             *    否则，如果type2是UPDATE
             *       在此domPath的NODE上增加更新参数
             *       name value
             *    否则
             *       在此domPath的NODE上增加删除参数
             *       name
             */
            for (var i = 0, maxi = jobs.length; i < maxi; i++) {
                if (
                    jobs[i].type1 == TYPE1.NODE &&
                    jobs[i].html !== undefined &&
                    jobs[i].html !== ''
                ) {
                    try {
                        jobs[i].nodes = toNode(jobs[i]);
                    } catch (e) {
                        self.system.console.error(self.system.logHead, e);
                    }
                }
            }

            for (var i = 0, maxi = jobs.length; i < maxi; i++) {
                if (jobs[i].type1 == TYPE1.NODE) {
                    if (jobs[i].type2 == TYPE2.ADD) {
                        toAdd(addNode(jobs[i].domPath, jobs[i]), highPriority, headPointer++);
                        jobs[i].nodes = null;
                    } else if (jobs[i].type2 == TYPE2.UPDATE) {
                        toAdd(editNode(jobs[i].domPath, jobs[i]), highPriority, headPointer++);
                        jobs[i].nodes = null;
                    } else {
                        if (jobs[i].deleteRange) {
                            for (var d = 0; d < jobs[i].deleteRange; d++) {
                                toAdd(delNode(jobs[i].domPath, jobs[i]), highPriority, headPointer++);
                            }
                        } else {
                            toAdd(delNode(jobs[i].domPath, jobs[i]), highPriority, headPointer++);
                        }
                    }
                } else {
                    if (jobs[i].type2 == TYPE2.ADD) {
                        toAdd(addAttr(jobs[i].domPath, jobs[i].name, jobs[i]), highPriority, headPointer++);
                    } else if (jobs[i].type2 == TYPE2.UPDATE) {
                        toAdd(editAttr(jobs[i].domPath, jobs[i].name, jobs[i]), highPriority, headPointer++);
                    } else {
                        toAdd(delAttr(jobs[i].domPath, jobs[i].name, jobs[i]), highPriority, headPointer++);
                    }
                }

                jobs[i] = null;
            }

            while (self.nextTick.length) {
                toAdd(self.nextTick.shift(), highPriority, headPointer++);
            }

            /**
             * 曾尝试对下面的语句做判断，如果已经在flush过程中了则不再触发额外的flush动作，换句话说就是，保持
             * flush中的setTimeout不会被同一时间多次触发。可是，这样处理后降低了浏览器处理的紧迫程度，会造成
             * 浏览器reflow频率依旧而导致的flush偷懒现象，即$Change调用的频率很高的情况下，queue大量激增造成
             * 积压，而浏览器的reflow慢条斯理跟不上速度。最终放弃这样的处理，按照实际情况来，如果$Change调用
             * 频率很高，那就多调用setTimeout，迫使浏览器提高reflow频率，直至reflow频率达到极限后挂起
             * JavaScript进程，降低queue生成速度以及调用setTimeout频率，直至queue清空。
             */
            flushQueue(highPriority, headPointer);
        }

        function toAdd(re, highPriority, from) {
            if (highPriority) {
                Relax.queue.splice(from, 0, re);
            } else {
                Relax.queue.push(re);
            }
        }

        function flushQueue(highPriority, range) {
            if (highPriority) {
                while (range-- >= 0) {
                    runOneQueue();
                }
            } else {
                if (Relax.queue.length) {
                    //将下面这段放到setTimeout里执行，以在高频率(>=1kHz)操作下让浏览器有喘息的空隙可以回收内存
                    setTimeout(function() {
                        runOneQueue();
                        flushQueue();
                    }, 0);
                }
            }
        }

        function runOneQueue() {
            try {
                Relax.queue.length && Relax.queue.shift()();
            } catch(e) {
                self.system.console.error(self.system.logHead, e);
            }
        }

        function pushRxId(target, value) {
            var rxIds,
                tmp,
                toInsert = false,
                toDelete = false,
                loop;

            if (value.indexOf(INSERT) == 0) {
                toInsert = true;
                value = value.slice(INSERT.length);
            } else if (value.indexOf(DELETE) == 0) {
                toDelete = true;
                value = value.slice(DELETE.length);
            }

            value = value.split(LEVEL_SPLITTER);
            for (var i = 0, maxi = value.length; i < maxi; i++) {
                //由于Relax内部的数组实际子元素的下标是从1开始的，所以这里需要把value中的下标都+1
                loop = splitLoop(value[i]);
                if (loop) {
                    loop[1]++;
                    value[i] = loop[0] + LOOP_SPLITTER.START + loop[1] + LOOP_SPLITTER.END;
                }
            }
            value = value.join(LEVEL_SPLITTER);

            rxIds = self.relaxMap.getRxIdByValue(value);

            if (!rxIds) {
                //新增加的数组子元素
                loop = splitLoop(value);
                if (tmp = self.relaxMap.value2rxId[loop[0] + LOOP_SPLITTER.ALL]) {
                    tmp = tmp[0].rxId + LOOP_SPLITTER.START + loop[1] + LOOP_SPLITTER.END;
                    addInsts([tmp]);
                    rxIds = [{rxId: tmp}];
                } else {
                    self.system.console.error(self.system.logHead, 'Value not found.');
                    return;
                }
            } else if (toInsert) {
                //插入的数组子元素
                rxIds = clone(rxIds);
                each(rxIds, function(one) {
                    updateAfterInsts(self.getTheAnaObj(toFather(one.rxId)).children, loop[1], +1);
                    addInsts([one.rxId], true);
                });
            } else if (toDelete) {
                //删除的数组子元素
                rxIds = clone(rxIds);
            }

            each(rxIds, function(one) {
                target.push(one.rxId);
            });
        }

        function tailRxId(array, tail) {
            each(array, function(one) {
                one.rxId += tail;
                if (one.children) {
                    tailRxId(one.children, tail);
                }
                if (one.attrs && one.attrs.special) {
                    tailRxId(one.attrs.special, tail);
                }
                if (one.value) {
                    tailRxId(one.value, tail);
                }
            });
            return array;
        }

        /**
         * 注意，objs必须按rxId从大到小排列
         */
        function cleanInsts(objs, onlyOne) {
            var index,
                one,
                tmp;

            while(one = objs[objs.length - 1]) {
                if (one.children) {
                    cleanInsts(one.children);
                }
                //由于ATTR的删除不走此逻辑，所以只需要考虑把children中的自己删掉
                //从relaxMap中删除此INSTS
                self.relaxMap.removeRxId(one.rxId);
                index = self.rxIdDetail[one.rxId].path.split(LEVEL_SPLITTER).slice(-1)[0];
                //从analysed中删除此INSTS
                tmp = self.getTheAnaObj(toFather(one.rxId)).children;
                tmp.splice(index, 1);
                //从rxIdDetail中删除此INSTS及其子级
                delete self.rxIdDetail[one.rxId];
                if (onlyOne) {
                    objs = [];
                    updateAfterInsts(tmp, index, -1);
                }
                tmp = null;
            }
        }

        function updateAfterInsts(objs, start, move) {
            var loopLevel,
                pathLevel;

            loopLevel = objs[0].rxId.split(LOOP_SPLITTER.START).length;
            pathLevel = self.rxIdDetail[objs[0].rxId].path.split(LEVEL_SPLITTER).length - 1;
            //移动这些Insts的下标和路径
            moveInsts(objs.slice(start), move, loopLevel, pathLevel);
        }

        function moveInsts(insts, move, loopLevel, pathLevel) {
            var oldRxId,
                newRxId,
                value,
                newValue,
                i = insts.length,
                index;

            //如果move是+1的话，需要从后往前，如果是-1的话，需要从前往后
            while(i--) {
                if (move == +1) {
                    index = i;
                } else {
                    index = insts.length - 1 - i;
                }

                oldRxId = insts[index].rxId;
                newRxId = changeLoop(oldRxId, loopLevel, move);

                //更新relaxMap中的下标
                value = self.relaxMap.getValueByRxId(oldRxId);
                if (value) {
                    value = value[0];
                    newValue = changeLoop(value.value, loopLevel, move);
                    self.relaxMap.add(newRxId, newValue, value.listen);
                    self.relaxMap.removeRxId(oldRxId);

                    //有时候还需要通过旧路径获取数据
                    if (reRoute == undefined) {
                        reRoute = {};
                    }
                    reRoute[newValue] = value.value;
                }

                //更新relaxCache中的下标
                self.relaxCache.set(newRxId, self.relaxCache.get(oldRxId));
                self.relaxCache.del(oldRxId);

                //更新rxIdDetail中的path和下标
                self.rxIdDetail[newRxId] = changePath(self.rxIdDetail[oldRxId], pathLevel, move);
                delete self.rxIdDetail[oldRxId];

                insts[index].rxId = newRxId;
                //更新analysed里后面元素的下标
                if (insts[index].children) {
                    moveInsts(insts[index].children, move, loopLevel, pathLevel);
                }
                if (insts[index].attrs && insts[index].attrs.special) {
                    moveInsts(insts[index].attrs.special, move, loopLevel, pathLevel);
                }
                if (insts[index].value) {
                    moveInsts(insts[index].value, move, loopLevel, pathLevel);
                }
            }
        }

        function changeLoop(old, loopLevel, move) {
            old = old.split(LOOP_SPLITTER.START);
            old[loopLevel] = old[loopLevel].split(LOOP_SPLITTER.END);
            old[loopLevel][0] = parseInt(old[loopLevel][0]) + move;
            old[loopLevel] = old[loopLevel].join(LOOP_SPLITTER.END);

            return old.join(LOOP_SPLITTER.START);
        }

        function changePath(detail, pathLevel, move) {
            detail.path = detail.path.split(LEVEL_SPLITTER);
            detail.path[pathLevel] = parseInt(detail.path[pathLevel]) + move;
            detail.path = detail.path.join(LEVEL_SPLITTER);

            return detail;
        }

        function processATTR(target, thisOne, needDomPath) {
            var re_tmp,
                rendered_tmp;

            re_tmp = {
                rxId: thisOne.rxId,
                type1: TYPE1.ATTR,
                name: thisOne.name
            };

            if (needDomPath) {
                re_tmp.domPath = getDomPath(thisOne.rxId);
            }

            //将value的部分渲染出来
            rendered_tmp = self.renderEngine(self.revertStruct(thisOne.value), getValue(thisOne), getIndex(thisOne));

            if (!self.relaxCache.changed(thisOne.rxId, rendered_tmp)) {
                return;
            }

            if (rendered_tmp !== '') {//如果value不是空
                re_tmp.value = rendered_tmp.trim();//拿到value结果

                //对布尔类型的属性要特殊处理
                if (hasThis(BOOLEAN_ATTRS, thisOne.name)) {
                    if (re_tmp.value == 'true') {
                        re_tmp.value = thisOne.name;
                    } else {
                        return;
                    }
                }

                if (!generated(thisOne.rxId)) {//如果未生成
                    re_tmp.type2 = TYPE2.ADD;//标记类型

                    self.rxIdDetail[thisOne.rxId].position = true;//更新position
                } else {//如果已生成
                    re_tmp.type2 = TYPE2.UPDATE;//标记类型
                }
            } else {//如果value是空
                if (generated(thisOne.rxId)) {
                    re_tmp.type2 = TYPE2.DELETE;//标记类型

                    cleanPath(thisOne.rxId);//删掉position和length
                } else {
                    return;
                }
            }

            target.push(re_tmp);
        }

        function processTEXT_NODE(target, thisOne, needDomPath) {
            var re_tmp = {
                    rxId: thisOne.rxId,
                    type1: TYPE1.NODE
                },
                position;

            if (!generated(thisOne.rxId)) {//如果未生成
                re_tmp.type2 = TYPE2.ADD;//标记类型
            } else {//重新生成的情况
                //因为TEXT_NODE不会变化，所以直接return
                return;
            }
            //TEXT_NODE只可能随着HTML_TAG父级被删掉，所以不考虑DELETE

            re_tmp.html = thisOne.content;//拿到html结果

            position = getPosition(thisOne.rxId);//计算位置

            if (needDomPath) {
                re_tmp.domPath = getDomPath(thisOne.rxId, position);//得出domPath
            }

            updateAfterPosition(thisOne.rxId, position);//更新后面元素的位置

            //由于不含value，所以不用添加到Map

            target.push(re_tmp);
        }

        function processLOOP_CHILD(target, thisOne, needDomPath) {
            var rxIdsToAdd = [],
                rendered_tmp,
                toRender;

            for (var j = 0, maxj = getValue(thisOne).length; j < maxj; j++) {
                rendered_tmp = thisOne.rxId + LOOP_SPLITTER.START + (j + 1) + LOOP_SPLITTER.END;
                if (self.rxIdDetail[rendered_tmp] == undefined) {
                    rxIdsToAdd.push(rendered_tmp);
                }
            }

            //添加这些rxId及这些rxId的children
            if (rxIdsToAdd.length) {
                addInsts(rxIdsToAdd);
            }

            toRender = self.getTheAnaObj(toFather(thisOne.rxId)).children.slice(1);

            //渲染
            rendered_tmp = renderTags(
                toRender,
                needDomPath
            );

            toRender = null;

            each(rendered_tmp, function(one) {
                target.push(one);
            });
        }

        function processGRAM_Basic(target, thisOne, needDomPath) {
            var position,
                valueScope,
                rendered_tmp;

            valueScope = getValue(thisOne);

            rendered_tmp = self.renderEngine(self.revertStruct([thisOne]), valueScope, getIndex(thisOne));

            if (!self.relaxCache.changed(thisOne.rxId, rendered_tmp)) {
                return;
            }

            if (!generated(thisOne.rxId)) {
                //如果未生成
                if (rendered_tmp !== '') {
                    position = getPosition(thisOne.rxId);

                    updateAfterPosition(thisOne.rxId, position);//更新后面元素的位置

                    target.push({
                        rxId: thisOne.rxId,
                        html: rendered_tmp,
                        type1: TYPE1.NODE,
                        type2: TYPE2.ADD//标记类型
                    });

                    if (needDomPath) {
                        target[target.length - 1].domPath = getDomPath(thisOne.rxId, position);//得出domPath
                    }
                }
            } else {
                //如果已生成
                position = getPosition(thisOne.rxId);

                if (rendered_tmp !== '') {
                    target.push({
                        rxId: thisOne.rxId,
                        html: rendered_tmp,
                        type1: TYPE1.NODE,
                        type2: TYPE2.UPDATE//标记类型
                    });

                    if (needDomPath) {
                        target[target.length - 1].domPath = getDomPath(thisOne.rxId, position);//得出domPath
                    }
                } else {
                    cleanPath(thisOne.rxId);//删掉position和length

                    updateAfterPosition(thisOne.rxId, position - 1);//更新后面元素的位置

                    target.push({
                        rxId: thisOne.rxId,
                        type1: TYPE1.NODE,
                        type2: TYPE2.DELETE//标记类型
                    });

                    if (needDomPath) {
                        target[target.length - 1].domPath = getDomPath(thisOne.rxId, position);//得出domPath
                    }
                }
            }
        }

        function processGRAM_Block(target, thisOne, needDomPath) {
            var rendered_tmp = [],
                position,
                valueScope,
                length,
                hasGenerated = false,
                valueNotPass = false;

            if (generated(thisOne.rxId)) {
                hasGenerated = true;
            }

            position = getPosition(thisOne.rxId);//计算位置，子级的domPath会依赖父级的position

            valueScope = getValue(thisOne);

            if (
                thisOne.grammarType === GRAMMAR_TYPE.IF && valueScope[thisOne.tagName] ||
                thisOne.grammarType === GRAMMAR_TYPE.IF_NOT && !valueScope[thisOne.tagName]
            ) {
                //IF或IF_NOT的情况。由于之前步骤收敛时会尽可能收敛到公共父级，所以即使布尔判断和之前一样，也需要检查子级
                rendered_tmp = renderTags(thisOne.children, needDomPath);
            } else if (
                thisOne.grammarType === GRAMMAR_TYPE.LOOP &&
                (
                    valueScope[thisOne.tagName] !== undefined ||
                    thisOne.tagName === GRAMMAR_TYPE.CURRENT_VALUE && valueScope !== undefined
                )
            ) {
                //LOOP的情况
                rendered_tmp = renderTags(thisOne.children.slice(0, 1), needDomPath);
            } else if (thisOne.grammarType === GRAMMAR_TYPE._LOOP_INSTS_ && valueScope !== undefined) {
                //_LOOP_INSTS_的情况
                rendered_tmp = renderTags(thisOne.children, needDomPath);
            } else {
                valueNotPass = true;
            }

            if (!hasGenerated) {
                //未生成
                if (rendered_tmp.length == 0) {
                    //数据判断没通过或子级结果为空
                    cleanPath(thisOne.rxId);//删掉position和length

                    if (thisOne.grammarType == GRAMMAR_TYPE._LOOP_INSTS_) {
                        cleanInsts([thisOne], true);
                    }
                } else {
                    //第一次生成
                    each(rendered_tmp, function(one) {
                        target.push(one);
                    });

                    length = getLength(thisOne.rxId, rendered_tmp);

                    self.rxIdDetail[thisOne.rxId].length = length;//更新length

                    updateAfterPosition(thisOne.rxId, position);//更新后面元素的位置
                }
            } else {
                //已生成
                if (valueNotPass) {
                    //数据判断没通过，从GRAMMAR_TAG发起的删除
                    target.push({
                        rxId: thisOne.rxId,
                        type1: TYPE1.NODE,
                        type2: TYPE2.DELETE,//标记类型
                        deleteRange: self.rxIdDetail[thisOne.rxId].length
                    });

                    if (needDomPath) {
                        target[target.length - 1].domPath = getDomPath(thisOne.rxId, position);//得出domPath
                    }

                    cleanPath(thisOne.rxId);//删掉position和length

                    updateAfterPosition(thisOne.rxId, position - 1);//更新后面元素的位置

                    if (thisOne.grammarType == GRAMMAR_TYPE._LOOP_INSTS_) {
                        cleanInsts([thisOne], true);
                    }
                } else if (rendered_tmp.length == 0) {
                    //子级没有任何变化
                } else {
                    //子级有变化
                    length = getLength(thisOne.rxId, rendered_tmp);
                    if (length == 0) {
                        //从子级发起的删除
                        each(rendered_tmp, function(one) {
                            target.push(one);
                        });

                        cleanPath(thisOne.rxId);//删掉position和length

                        updateAfterPosition(thisOne.rxId, position - 1);//更新后面元素的位置

                        if (thisOne.grammarType == GRAMMAR_TYPE._LOOP_INSTS_) {
                            cleanInsts([thisOne], true);
                        }
                    } else {
                        //子级的更新
                        each(rendered_tmp, function(one) {
                            target.push(one);
                        });

                        self.rxIdDetail[thisOne.rxId].length = length;//更新length

                        updateAfterPosition(thisOne.rxId, position);//更新后面元素的位置
                    }
                }
            }
        }

        function processHTML_TAG(target, thisOne, needDomPath) {
            var re_tmp,
                rendered_attr = [],
                rendered_child = [],
                rendered_tmp1,
                rendered_tmp2,
                output_id,
                position,
                hasGenerated = false,
                eventName;

            if (generated(thisOne.rxId)) {
                hasGenerated = true;
            }

            if (thisOne.attrs && thisOne.attrs.special) {
                //如果有special参数
                rendered_attr = renderTags(thisOne.attrs.special, hasGenerated);
            }

            if (thisOne.children && thisOne.children.length) {//如果有子级
                //拿到子级渲染结果
                rendered_child = renderTags(thisOne.children, hasGenerated);
            }

            if (!hasGenerated) {//如果未生成
                re_tmp = {
                    rxId: thisOne.rxId,
                    type1: TYPE1.NODE,
                    type2: TYPE2.ADD
                };

                if (TABLE_TAGS[thisOne.tagName] !== undefined) {
                    re_tmp.eleTag = TABLE_TAGS[thisOne.tagName];
                }

                //整理特殊属性结果，记录非空部分
                rendered_tmp1 = [];
                each(rendered_attr, function(one) {
                    rendered_tmp1.push([one.name, '=', '"', one.value, '"'].join(''));
                });

                if (thisOne.attrs && thisOne.attrs.normal) {
                    //如果有normal参数
                    rendered_tmp2 = thisOne.attrs.normal.join(' ');

                    //整理普通属性结果，记录非空部分
                    if (rendered_tmp2 !== '') {
                        rendered_tmp1.push(rendered_tmp2);
                        eventName = eventOnTag(thisOne.attrs.normal);
                        //如果含有listener且没有EVENT_ON_TAG则加上EVENT_ON_TAG
                        if (hasListener(thisOne)) {
                            if (!eventName) {
                                //EVENT_ON_TAG只能是普通属性
                                rendered_tmp1.push([
                                    ' ',
                                    EVENT_ON_TAG,
                                    '="',
                                    thisOne.rxId,
                                    '"'
                                ].join(''));
                                putIntoRxToId(thisOne.rxId, thisOne.rxId);
                            } else {
                                if (self.system.rxToId[eventName]) {
                                    self.system.console.error(
                                        self.system.logHead,
                                        'Dulplicated ' + EVENT_ON_TAG + ' is not allowed on tag with listener.'
                                    );
                                }
                                putIntoRxToId(eventName, thisOne.rxId);
                            }
                        } else {
                            putIntoRxToId(eventName, thisOne.rxId);
                        }
                    }
                }

                output_id = '';
                if (self.config.debug) {
                    output_id = [' ', ID_ON_TAG, '=', '"', thisOne.rxId, '"'].join('');
                }

                if (rendered_tmp1.length) {//如果有参数内容
                    rendered_tmp1 = ' ' + rendered_tmp1.join(' ');
                } else {//如果没有参数内容
                    rendered_tmp1 = '';
                }

                //得到TAG部分
                re_tmp.html = [
                    '<',
                    thisOne.tagName,
                    rendered_tmp1,
                    output_id,
                    '>'
                ].join('');

                if (thisOne.paired === true) {
                    //如果不是闭合标签
                    re_tmp.html += [
                        '</',
                        thisOne.tagName,
                        '>'
                    ].join('');
                }

                position = getPosition(thisOne.rxId);//计算位置

                if (needDomPath) {
                    re_tmp.domPath = getDomPath(thisOne.rxId, position);//得出domPath
                }

                //整理结果
                each(rendered_child, function(one) {
                    if (!re_tmp.children) {
                        re_tmp.children = [];
                    }
                    re_tmp.children.push(one);
                });

                updateAfterPosition(thisOne.rxId, position);//更新后面元素的位置

                target.push(re_tmp);
            } else {//如果已生成
                each(rendered_attr, function(one) {
                    target.push(one);
                });

                each(rendered_child, function(one) {
                    target.push(one);
                });
            }
            //由于HTML_TAG不会自己删除自己，所以它没有DELETE情况
        }

        function putIntoRxToId(eventName, rxId) {
            if (!self.system.rxToId[eventName]) {
                self.system.rxToId[eventName] = [];
            }
            if (self.system.rxToId[eventName].indexOf(rxId) === -1) {
                self.system.rxToId[eventName].push(rxId);
            }
        }

        function hasListener(obj) {
            var has = false;

            if (obj.attrs && obj.attrs.special) {
                for (var i = 0, maxi = obj.attrs.special.length; i < maxi; i++) {
                    //listener需要其value只有listener
                    if (self.relaxMap.getValueByRxId(obj.attrs.special[i].rxId)[0].listen) {
                        has = true;
                        break;
                    }
                }
            }

            return has;
        }

        function eventOnTag(normals) {
            var has;

            for (var i = 0, maxi = normals.length; i < maxi; i++) {
                if (normals[i].slice(0, EVENT_ON_TAG.length + 1) === EVENT_ON_TAG + '=') {
                    has = normals[i].slice(EVENT_ON_TAG.length + 2, -1);
                    break;
                }
            }

            return has;
        }

        function getLength(rxId, array) {
            var length = self.rxIdDetail[rxId].length || 0,
                fa = undefined,
                toNextTmp;

            //记录第一层子级生成的数量
            for (var i = 0, maxi = array.length; i < maxi; i++) {
                toNextTmp = false;

                while((fa = toFather(fa || array[i].rxId)) && (fa = self.getTheAnaObj(fa))) {
                    if (fa.grammarType != undefined) {
                        if (fa.rxId == rxId) {
                            break;
                        } else {
                            fa = fa.rxId;
                        }
                    } else {
                        toNextTmp = true;
                        break;
                    }
                }

                fa = undefined;

                if (toNextTmp) {
                    continue;
                }

                if (array[i].type2 == TYPE2.ADD) {
                    length++;
                } else if (array[i].type2 == TYPE2.DELETE) {
                    if (array[i].deleteRange) {
                        length -= array[i].deleteRange;
                    } else {
                        length--;
                    }
                }
            }

            return length;
        }

        function cloneTags(array) {
            var re = [],
                kind;

            each(array, function(one) {
                kind = kindOf(one);
                if (kind == '[object Object]') {
                    re.push(clone(one));
                } else if (kind == '[object Array]') {
                    re.push(cloneTags(one));
                }
            });

            return re;
        }

        function cleanPath(rxId) {
            var obj = self.getTheAnaObj(rxId);

            delete self.rxIdDetail[rxId].position;
            delete self.rxIdDetail[rxId].length;
            self.relaxCache.del(rxId);

            //同时需要将子元素的position也删掉
            if (obj.attrs && obj.attrs.special) {
                each(obj.attrs.special, function(one) {
                    if (generated(one.rxId)) {
                        cleanPath(one.rxId);
                    }
                });
            }
            if (obj.children && obj.children.length) {
                each(obj.children, function(one) {
                    if (generated(one.rxId)) {
                        cleanPath(one.rxId);
                    }
                });
            }
        }

        function updatePosition(rxId, position) {
            if (self.rxIdDetail[rxId].position != position) {
                self.rxIdDetail[rxId].position = position;
            }
        }

        /**
         * 计算rxId在同级中的位置
         */
        function getPosition(rxId) {
            var fa,
                position = 0;

            fa = toFather(rxId);

            fa = self.getTheAnaObj(fa);

            if (fa.children) {
                fa = fa.children;
            }

            for (var i = 0, maxi = fa.length; i < maxi; i++) {
                if (fa[i].rxId !== rxId) {
                    if (generated(fa[i].rxId) && fa[i].grammarType != GRAMMAR_TYPE._LOOP_CHILD_) {
                        //只累加已经生成元素的position
                        position = self.rxIdDetail[fa[i].rxId].position + 1;
                        if (self.rxIdDetail[fa[i].rxId].length) {//0和undefined的情况都不属于
                            position += self.rxIdDetail[fa[i].rxId].length - 1;
                        }
                    }
                } else {
                    break;
                }
            }

            updatePosition(rxId, position);

            return position;
        }

        /**
         * 找到此rxId的domPath
         *
         * @param {String} rxId
         * @param {Number} [position] 只有是元素的属性时没有position
         */
        function getDomPath(rxId, position) {
            var re,
                fa,
                fatherPath;

            if (position !== undefined) {
                re = [position];
            } else {
                re = [];
            }

            fa = toFather(rxId);

            /**
             * 如果遇到了GRAMMAR_TAG的父级，则继续向上查找。
             * 由于GRAMMAR_TAG实际上不存在DOM中，可以将其视为重叠在一起
             * 的TAG，此时需要处理position改变的问题。
             */
            while (fa !== '' && self.getTheAnaObj(fa).grammarType !== undefined) {
                if (re.length) {
                    re[0] += self.rxIdDetail[fa].position;
                }

                fa = toFather(fa);
            }

            if (fa) {
                fatherPath = getDomPath(fa, self.rxIdDetail[fa].position);
                re = fatherPath.concat(re);
            }

            return re;
        }

        /**
         * 更新后面相邻元素的position
         */
        function updateAfterPosition(rxId, from) {
            var fa = self.getTheAnaObj(toFather(rxId)),
                length = self.rxIdDetail[rxId].length,
                start = false;

            if (length !== undefined) {
                //一般至少是1，但如果是_LOOP_CHILD_则会是0
                length = length - 1;
            } else {
                length = 0;
            }

            if (fa.children) {
                fa = fa.children;
            }

            for (var i = 0, maxi = fa.length; i < maxi; i++) {
                if (fa[i].rxId === rxId) {
                    start = true;
                } else if (start && self.rxIdDetail[fa[i].rxId].position !== undefined) {
                    from++;
                    self.rxIdDetail[fa[i].rxId].position = from + length;
                }
            }
        }

        function fatherIn(list, child) {
            var re = false;

            child = toFather(child);

            while(child != '' && !hasThis(list, child)) {
                child = toFather(child);
            }

            if (child != '') {
                re = true;
            }

            return re;
        }

        /**
         * 判断两个domPath是否一致
         *
         * @param {String} pathA
         * @param {String} pathB
         */
        function samePath(pathA, pathB) {
            var re = true;

            if (pathA.length != pathB.length) {
                re = false;
            } else {
                for (var i = 0, maxi = pathA.length; i < maxi; i++) {
                    if (pathA[i] != pathB[i]) {
                        re = false;
                        break;
                    }
                }
            }

            return re;
        }

        /**
         * 判断两个domPath是否相邻
         *
         * @param {String} pathA
         * @param {String} pathB
         */
        function adjacent(pathA, pathB) {
            var re = false;

            if (pathA.slice(-1) == (pathB.slice(-1) - 1) && samePath(pathA.slice(0, -1), pathB.slice(0, -1))) {
                re = true;
            }

            return re;
        }
        
        /**
         * 根据changed删除数组中undefined的子元素
         * 
         * @param {Array} array
         */
        function cleanData(array) {
            //TODO clean undefined array child
        }

        /**
         * 合并相邻的job
         *
         * @param {Array} array
         */
        function mergeJobs(array) {
            var i = array.length - 1,
                tmp;

            while(i > 0) {
                if (
                    array[i - 1].type2 == TYPE2.ADD &&
                    array[i - 1].type2 == array[i].type2 &&
                    adjacent(array[i - 1].domPath, array[i].domPath)
                ) {//只有增加值可以合并，修改或删除都涉及到可能要把原有元素删除，而删除只能逐个删除。
                    array[i - 1].batch = [];
                    tmp = array[i].batch;
                    delete array[i].batch;
                    array[i - 1].batch.push(array.splice(i, 1)[0]);
                    if (tmp != undefined) {
                        array[i - 1].batch = array[i - 1].batch.concat(tmp);
                        tmp = undefined;
                    }
                }
                i--;
            }
        }

        function hasThis(array, ele) {
            return array.indexOf(ele) != -1;
        }

        function generated(rxId) {
            return rxId === '' ? true : self.rxIdDetail[rxId] && self.rxIdDetail[rxId].position !== undefined;
        }

        /**
         * 根据rxId找到其父级
         *
         * @param {String} rxId
         */
        function toFather(rxId) {
            var path,
                tmp;

            path = self.rxIdDetail[rxId];

            if (path === undefined) {
                //说明是尚未生成的_LOOP_INSTS_
                path = splitLoop(rxId);
                path = self.rxIdDetail[path[0]];
            }

            path = path.path;

            tmp = path.split(LEVEL_SPLITTER);

            tmp = tmp.slice(0, tmp.length - 1);

            //跳过ATTR_SPLITTER和VALUE_SPLITTER
            while(tmp.length && (tmp[tmp.length - 1] === ATTR_SPLITTER || tmp[tmp.length - 1] === VALUE_SPLITTER)) {
                tmp = tmp.slice(0, tmp.length - 1);
            }

            tmp = tmp.join(LEVEL_SPLITTER);

            if (tmp === '') {
                return '';
            } else {
                return self.getAnaObjFromPath(tmp).rxId;
            }
        }

        function toNode(job) {
            var html,
                type,
                frag;

            type = job.eleTag || 'div';

            if (IGNOREBLANK && job.html == ' ') {
                Relax.reuseNode[type].innerText = job.html;//为了兼容IE10以下
            } else {
                Relax.reuseNode[type].innerHTML = job.html;
                //由于涉及到HTML Entity以及Unicode的解码情况比较复杂，所以暂时使用innerHTML
            }

            if (Relax.reuseNode[type].childNodes.length != 1) {
                self.system.console.error(self.system.logHead, 'You need a div wrapper for this: ', job.html);
                return;
            }

            html = Relax.reuseNode[type].childNodes[0];

            cleanDomChild(Relax.reuseNode[type]);

            if (html === undefined) {
                self.system.console.error(self.system.logHead, 'Cannot convert', job.html, 'to Node');
                return;
            }

            if (job.children) {
                while(job.children.length) {
                    html.appendChild(toNode(job.children.splice(0, 1)[0]));
                }
                delete job.children;
            }

            if (job.batch) {
                frag = Relax.reuseNode['frag'].pop() || document.createDocumentFragment();
                frag.appendChild(html);
                html = null;

                while(job.batch.length) {
                    frag.appendChild(toNode(job.batch.splice(0, 1)[0]));
                }

                delete job.batch;

                return frag;
            } else {
                return html;
            }
        }

        function subPath(path) {
            return '.childNodes[' + path.join('].childNodes[') + ']';
        }

        function addQueue(parent, child, job, task) {
            var parentString = 'document.getElementById(id)',
                childString = 'null';

            if (child) {
                childString = parentString + subPath(child);
            }

            if (parent.length) {
                parentString += subPath(parent);
            }

            return (function(id, nodes, body) {
                var func;

                func = (new Function(
                    'id,nodes',
                    body
                )).bind(VACUUM, id, nodes);

                func();

                func = null;

                if (kindOf(nodes) == '[object DocumentFragment]') {
                    Relax.reuseNode['frag'].push(nodes);
                }
                nodes = null;
            }).bind(VACUUM, self.container, job.nodes, task(parentString, childString));
        }

        function addNode(domPath, job) {
            return addQueue(domPath.slice(0, -1), domPath, job, function(parent, child) {
                return parent + '.insertBefore(nodes,' + child + '||null);nodes=null;';
            });
        }

        function editNode(domPath, job) {
            return addQueue(domPath.slice(0, -1), domPath, job, function(parent, child) {
                return parent + '.replaceChild(nodes,' + child + ');nodes=null;';
            });
        }

        function delNode(domPath, job) {
            return addQueue(domPath.slice(0, -1), domPath, job, function(parent, child) {
                return parent + '.removeChild(' + child + ');';
            });
        }

        function addAttr(domPath, name, job) {
            if (name == 'class') {
                //兼容IE7
                job.nodes = job.value;
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '["className"]=nodes;';
                });
            } else if (hasThis(BOOLEAN_ATTRS, name)) {
                //由于经过渲染后，value会变成字符串，所以这里做特殊处理
                job.nodes = job.value == 'true';
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '["' + name + '"]=nodes;';
                });
            } else {
                job.nodes = job.value;
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '.setAttribute("' + name + '",nodes);';
                });
            }
        }

        function editAttr(domPath, name, job) {
            return addAttr(domPath, name, job);
        }

        function delAttr(domPath, name, job) {
            if (name == 'class') {
                //兼容IE7
                job.nodes = undefined;
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '["className"]="";';
                });
            } else if (hasThis(BOOLEAN_ATTRS, name)) {
                job.nodes = false;
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '["' + name + '"]=nodes;';
                });
            } else {
                job.nodes = undefined;
                return addQueue(domPath, undefined, job, function(parent) {
                    return parent + '.removeAttribute("' + name + '");';
                });
            }
        }
    };

    /**
     * 根据path写法找到对应的数据所在的对象
     *
     * @param {String} path
     */
    Relax.prototype.getValueByPath = function(path) {
        var self = this,
            re = self.$Data,
            tree,
            key,
            tmp;

        if (kindOf(re) != "[object Object]") {
            self.system.console.error(self.system.logHead, '$Data should be an Object.');
        }

        tree = path.split(LEVEL_SPLITTER).slice(1);

        for (var i = 0, maxi = tree.length; i < maxi; i++) {
            tmp = splitLoop(tree[i]);
            if (tmp != undefined) {
                tree[i] = tmp[0].split('.');
                for (var j = 0, maxj = tree[i].length; j < maxj; j++) {
                    key = tree[i].shift();
                    if (key != GRAMMAR_TYPE.CURRENT_VALUE) {
                        re = re[key];
                    }
                }
                re = re[tmp[1] - 1];
            }
        }

        return re;
    };

    /**
     * Relax的销毁
     */
    Relax.prototype.destroy = function() {
        var self = this;
    };

    /**
     * 从函数的注释中提取模板，类似于heredoc。
     * 将函数序列化后，把注释前后的所有字符删掉，把HTML注释也删掉，最后把换行符及前后的空格删掉。
     * 注意，第三个replace，也就是对换行符前后空格的处理。
     * 如果不这样处理，html插入到DOM中后，这些空格部分都会成为TEXT_NODE。
     *
     * @param {Object} module
     */
    Relax.T = function(module) {
        module.template = module.template
            .toString()
            .replace(/^[^*]*\/\*|\*\/[^*]*$/g, "");
    };

    /**
     * 初始化RelaxMap
     */
    Relax.prototype.initRelaxMap = function() {
        var self = this;

        self.relaxMap = new RelaxMap(self.analysed, self.rxIdDetail);
    };

    /**
     * 初始化RelaxCache
     */
    Relax.prototype.initRelaxCache = function() {
        var self = this;

        self.relaxCache = new RelaxCache(
            self.config.cacheMax,
            self.system,
            function(original) {
                return original.replace(new RegExp('^' + self.container), ID_ON_TAG);
            }
        );
    };

    /**
     * 递归analysed，在rxIdDetail上记录path
     *
     * rxIdDetail = {
     *      'some:123': {
     *          position: 12,   此属性同时也用于判断元素是否已生成
     *          path: '1-3-4',
     *          length: 10      此属性用于更新后面同级元素的position
     *      }
     *  }
     *
     * @param {Array} array
     * @param {String} path
     * @param {String} valueScope
     * @param {Boolean} [isINSTS]
     */
    Relax.prototype.getRxIdPaths = function(array, path, valueScope, isINSTS) {
        var self = this,
            valueRxId,
            value,
            scope,
            index,
            isListen;

        for (var i = 0, maxi = array.length; i < maxi; i++) {
            scope = valueScope;
            isListen = false;

            if (self.rxIdDetail[array[i].rxId] === undefined) {
                self.rxIdDetail[array[i].rxId] = {};
            }

            if (isINSTS && array[i].grammarType == GRAMMAR_TYPE._LOOP_INSTS_) {
                index = splitLoop(array[i].rxId)[1];
                self.rxIdDetail[array[i].rxId].path = path + LEVEL_SPLITTER + index;
            } else {
                index = i;
                self.rxIdDetail[array[i].rxId].path = path + LEVEL_SPLITTER + index;
            }

            //添加到relaxMap
            if (array[i].grammarType !== undefined) {
                //如果是属性的value，则只记录到属性的rxId
                if (isValue(array[i].rxId)) {
                    valueRxId = self.getAttObjFromPath(path).rxId;
                } else {
                    valueRxId = array[i].rxId;
                }

                if (
                    array[i].grammarType == GRAMMAR_TYPE._LOOP_CHILD_ ||
                    array[i].grammarType == GRAMMAR_TYPE._LOOP_INSTS_
                ) {
                    value = valueScope;
                } else {
                    value = valueScope + LEVEL_SPLITTER + array[i].tagName;

                    if (array[i].grammarType === GRAMMAR_TYPE.LOOP) {
                        //用于后面递归子元素
                        if (!isINSTS) {
                            scope += LEVEL_SPLITTER + array[i].tagName + LOOP_SPLITTER.ALL;
                        } else {
                            scope += LEVEL_SPLITTER + array[i].tagName + LOOP_SPLITTER.START + index + LOOP_SPLITTER.END;
                        }
                    } else if (array[i].grammarType === GRAMMAR_TYPE.LISTEN) {
                        isListen = true;
                    }
                }

                if (!isINSTS) {
                    self.relaxMap.add(valueRxId, value, isListen);
                } else if (
                    valueRxId.split(LOOP_SPLITTER.START).length ==
                    value.split(LOOP_SPLITTER.START).length
                ) {
                    self.relaxMap.add(valueRxId, value, isListen);
                }
            }

            value = null;

            if (array[i].children) {
                self.getRxIdPaths(array[i].children, [path, index].join(LEVEL_SPLITTER), scope, isINSTS);
            }
            if (array[i].attrs && array[i].attrs.special) {
                self.getRxIdPaths(array[i].attrs.special, [path, index, ATTR_SPLITTER].join(LEVEL_SPLITTER), scope, isINSTS);
            }
            if (array[i].value) {
                self.getRxIdPaths(array[i].value, [path, index, VALUE_SPLITTER].join(LEVEL_SPLITTER), scope, isINSTS);
            }

            scope = null;
        }

        /**
         * 判断是不是属性的value
         *
         * @param {String} rxId
         */
        function isValue(rxId) {
            return self.rxIdDetail[rxId].path.indexOf(VALUE_SPLITTER) != -1;
        }
    };

    /**
     * 创建属于自己的defineProperties
     * 由于不同实例debug设置可能不同的原因，需要放到prototype里
     */
    Relax.prototype.defineProperties = (function() {
        var self = this;

        if (/MSIE\ [678]/.test(window.navigator.userAgent)) {
            var VB_ID = 0;

            window.execScript([
                'Function parseVB(code)',
                '\tExecuteGlobal(code)',
                'End Function'
            ].join('\r\n'), 'VBScript');

            return function(obj, props) {
                var buffer = [],
                    className,
                    command = [],
                    key,
                    value_through = [],
                    cb_poll = {},
                    prevent_double_call = {},
                    re;

                if (!isObj(obj)) {
                    throw new TypeError('Object.defineProperties called on non-object');
                }

                if (props == undefined) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                for (key in props) {
                    if (props.hasOwnProperty(key)) {
                        if (!isObj(props[key])) {
                            throw new TypeError('Property description must be an object');
                        }
                        if (notTrue(props[key]['configurable'])) {
                            throw new TypeError('VBS\'s object can not has configurable key');
                        }
                        if (notTrue(props[key]['enumerable'])) {
                            throw new TypeError('Can\'t support non-enumerable key through VBS');
                        }
                        if (props[key]['set'] || props[key]['get']) {
                            //accessor descriptors
                            delete obj[key];
                            if (props[key]['set']) {
                                defineSet(key, props[key]['set']);
                            }
                            if (props[key]['get']) {
                                defineGet(key, props[key]['get']);
                            }
                        } else if (props[key]['writable'] !== undefined || props[key]['value'] !== undefined) {
                            //data descriptors
                            if (notTrue(props[key]['writable'])) {
                                //当做getter处理
                                defineGet(key, function() {
                                    return props[key]['value'];
                                });
                            } else {
                                defineNormalKey(key);
                                value_through.push([key, props[key]['value']]);
                            }
                        }
                    }
                }

                for (key in obj) {
                    if (obj.hasOwnProperty(key)) {
                        defineNormalKey(key);
                        value_through.push([key, obj[key]]);
                    }
                }

                buffer.unshift(
                    '\r\n\tPrivate [_acc], [_pro]',
                    '\tPublic Default Function [self](proxy)',
                    '\t\tSet [_pro] = proxy',
                    '\t\tSet [self] = me',
                    '\tEnd Function'
                );

                buffer.push('End Class');

                buffer = buffer.join('\r\n');

                className = 'VB' + (VB_ID++);

                command.push('Class ' + className + buffer);
                command.push([
                            'Function ' + className + 'F(proxy)',
                            '\tSet ' + className + 'F = (New ' + className + ')(proxy)',
                        'End Function'
                    ].join('\r\n')
                );

                command = command.join('\r\n');

                window['parseVB'](command);
                re = window[className + 'F'](proxy);

                for (var i = 0, maxi = value_through.length; i < maxi; i++) {
                    re[value_through[i][0]] = value_through[i][1];
                }

                return re;

                function defineSet(key, callback) {
                    cb_poll[key + '_set'] = callback;
                    buffer.push(
                            '\tPublic Property Let [' + key + '](value)',
                            '\t\tCall [_pro](me, "set", "' + key + '", value)',
                        '\tEnd Property',
                            '\tPublic Property Set [' + key + '](value)',
                            '\t\tCall [_pro](me, "set", "' + key + '", value)',
                        '\tEnd Property'
                    );
                }

                function defineGet(key, callback) {
                    cb_poll[key + '_get'] = callback;
                    buffer.push(
                            '\tPublic Property Get [' + key + ']',
                        '\tOn Error Resume Next',//必须优先使用set语句,否则它会误将数组当字符串返回
                            '\t\tSet [' + key + '] = [_pro](me, "get", "' + key + '")',
                        '\tIf Err.Number <> 0 Then',
                            '\t\t[' + key + '] = [_pro](me, "get", "' + key + '")',
                        '\tEnd If',
                        '\tOn Error Goto 0',
                        '\tEnd Property'
                    );
                }

                function defineNormalKey(key) {
                    buffer.push('\tPublic [' + key + ']');
                }

                function notTrue(t) {
                    return t === undefined || t === false;
                }

                function isObj(t) {
                    return Object.prototype.toString.call(t) === '[object Object]';
                }

                function proxy(me, type, key, value) {
                    if (type == 'get') {
                        if (!prevent_double_call[key]) {
                            cb_poll[key + '_get'].apply(re, [value]);
                            prevent_double_call[key] = true;
                        } else {
                            prevent_double_call[key] = false;
                        }
                    } else {
                        cb_poll[key + '_set'].apply(re, [value]);
                    }
                }
            };
        } else {
            return function(obj, props) {
                var re;

                re = Object.defineProperties(obj, props);

                if (self.config.debug && Object.observe) {
                    Object.observe(re, function(change) {
                        for (var i = 0, maxi = change.length; i < maxi; i++) {
                            if (change[i].type == 'add') {
                                throw new TypeError('You can\'t add new key if you want to support IE 8 and below');
                            }
                        }
                    });
                }

                return re;
            };
        }
    })();

    /**
     * 构建$Data白名单
     */
    Relax.prototype.buildDataWhite = function() {
        var self = this,
            scope,
            thisKey,
            isLoop;

        self.system.dataWhite = {};

        for (var key in self.relaxMap.value2rxId) {
            //循环每一个键值
            scope = undefined;
            if (isOwnProp(self.relaxMap.value2rxId, key)) {
                key = key.split(LEVEL_SPLITTER);
                for (var i = 0, maxi = key.length; i < maxi; i++) {
                    //循环每一级
                    isLoop = false;
                    thisKey = key[i];
                    if (thisKey === '') {
                        scope = self.system.dataWhite;
                    } else {
                        if (thisKey.slice(-1 * LOOP_SPLITTER.ALL.length) == LOOP_SPLITTER.ALL) {
                            isLoop = true;
                            thisKey = thisKey.slice(0, -1 * LOOP_SPLITTER.ALL.length);
                        }
                        thisKey = thisKey.split('.');

                        if (thisKey.indexOf(LOOP_KEY) != -1) {
                            self.system.console.error(self.system.logHead, 'Do not use this key in your $Data: ' + LOOP_KEY);
                        }

                        for (var j = 0, maxj = thisKey.length; j < maxj; j++) {
                            //循环对象每一级
                            if (thisKey[j] == GRAMMAR_TYPE.INDEX || thisKey[j] == GRAMMAR_TYPE.CURRENT_VALUE) {
                                continue;
                            }
                            if (scope[thisKey[j]] === undefined) {
                                scope[thisKey[j]] = {};
                            }
                            scope = scope[thisKey[j]];
                        }

                        if (isLoop) {
                            if (scope[LOOP_KEY] === undefined) {
                                scope[LOOP_KEY] = {};
                            }
                            scope = scope[LOOP_KEY];
                        }
                    }
                }
            }
        }
    };

    /**
     * 将structure转换成字符串
     *
     * @param {Array} array
     */
    Relax.prototype.revertStruct = function(array) {
        var self = this,
            re = '',
            attrs,
            child;

        each(array, function(one) {
            if (one.tagName === TEXT_NODE) {
                re += one.content;
            } else if (one.grammarType !== undefined) {
                if (one.paired) {
                    child = one.children || [];
                    child = self.revertStruct(child);
                    re += [
                        self.config.startTag,
                        one.grammarType,
                        one.tagName,
                        self.config.endTag,
                        child,
                        self.config.startTag,
                        GRAMMAR_TYPE.END,
                        one.tagName,
                        self.config.endTag
                    ].join('');
                } else if (
                    one.grammarType == GRAMMAR_TYPE.INDEX ||
                    one.grammarType == GRAMMAR_TYPE.CURRENT_VALUE
                    ) {
                    re += [
                        self.config.startTag,
                        one.grammarType,
                        self.config.endTag
                    ].join('');
                } else {
                    re += [
                        self.config.startTag,
                        one.grammarType,
                        one.tagName,
                        self.config.endTag
                    ].join('');
                }
            } else {
                if (one.attrs) {
                    attrs = [];
                    if (one.attrs.special) {
                        each(one.attrs.special, function(s) {
                            attrs.push([s.name + '=' + '"' + self.revertStruct(s.value) + '"'].join(''));
                        });
                    }
                    if (one.attrs.normal) {
                        attrs.push(one.attrs.normal.join(' '));
                    }

                    attrs = attrs.join(' ');

                    if (attrs !== '') {
                        attrs = ' ' + attrs;
                    }
                } else {
                    attrs = '';
                }

                if (one.paired) {
                    child = one.children || [];
                    child = self.revertStruct(child);
                    re += ['<', one.tagName, attrs, '>', child, '</', one.tagName, '>'].join('');
                } else {
                    re += ['<', one.tagName, attrs, '>'].join('');
                }
            }
        });

        return re;
    };
                    
    /**
     * Relax的模板渲染引擎，只负责根据字符模板和数据生成字符串。
     *
     * @param {String} str
     * @param {Object} data
     * @param {Number} [index]
     *
     * 关于标签的用法：
     *    值替换：{{value}}以及{{_VALUE_}}(对于简单数据的情况)
     *    循环：{{#value}}{{/value}}以及{{_VALUE_}}(对于简单Array的情况)，{{_INDEX_}}(序号)
     *    判断：{{?value}}{{/value}} {{!value}}{{/value}}
     *    需要监听的值：{{$value}}
     */
    Relax.prototype.renderEngine = function(str, data, index) {
        var self = this,
            re = "",
            pointer,
            tail = str,
            strArray = [],
            grammar = '',
            begin = '',
            tokenArray = [],
            subTemp = '',
            value;

        function isBlock(g) {
            return g === GRAMMAR_TYPE.LOOP  ||
                g === GRAMMAR_TYPE.IF    ||
                g === GRAMMAR_TYPE.IF_NOT;
        }

        while ((pointer = tail.indexOf(self.config.startTag)) != -1) {
            //保存tail中，下一个语法TAG之前的部分
            strArray.push(tail.substr(0, pointer));
            tail = tail.substr(pointer += self.config.startTag.length);

            //取出语法TAG之间的部分
            grammar = tail.substr(0, pointer = tail.indexOf(self.config.endTag));

            //tail只剩下此语法TAG之后的部分
            tail = tail.substr(pointer += self.config.endTag.length);

            begin = grammar.charAt(0);
            if (isBlock(begin)) {
                grammar = grammar.substr(1);
                subTemp = tail.substr(
                    0,
                    pointer = tail.indexOf(self.config.startTag + GRAMMAR_TYPE.END + grammar)
                );

                //结尾不用解析了，直接按照理论长度略过
                pointer += grammar.length + (self.config.startTag.length + 1 + self.config.endTag.length);
                tail = tail.substr(pointer);

                //保存此语法TAG
                tokenArray.push({type: begin, key: grammar, str: subTemp});
            } else if (begin === GRAMMAR_TYPE.LISTEN) {
                grammar = grammar.substr(1);
                tokenArray.push(grammar);
            } else {
                tokenArray.push(grammar);
            }
        }

        strArray.push(tail);
        /**
         * 至此，普通字符与语法TAG都已经保存好了
         * block的部分都保存在了str: subTemp
         */

        if (strArray.length != tokenArray.length + 1) {
            self.system.console.error(self.system.logHead, 'Tag not closed.');
            return;
        }

        try {
            for (var i = 0, maxi = tokenArray.length; i < maxi; i++) {
                if (kindOf(tokenArray[i]) === '[object Object]') {
                    if (tokenArray[i].type === GRAMMAR_TYPE.LOOP) {
                        //LOOP的情况
                        re += strArray[i];
                        each(data[tokenArray[i].key], function(e, index) {
                            re += self.renderEngine(tokenArray[i].str, e, index);
                        });
                    } else if (tokenArray[i].type === GRAMMAR_TYPE.IF) {
                        //IF的情况
                        re += strArray[i];
                        if (!!data[tokenArray[i].key]) {
                            re += self.renderEngine(tokenArray[i].str, data);
                        }
                    } else if (tokenArray[i].type === GRAMMAR_TYPE.IF_NOT) {
                        //IF_NOT的情况
                        re += strArray[i];
                        if (!data[tokenArray[i].key]) {
                            re += self.renderEngine(tokenArray[i].str, data);
                        }
                    } else {
                        //因为上面做了isBlock判断，所以不会出现这种情况
                    }
                } else if (tokenArray[i] === GRAMMAR_TYPE.CURRENT_VALUE) {
                    //CURRENT_VALUE的情况
                    re += strArray[i] + '' + data;
                } else if (tokenArray[i] === GRAMMAR_TYPE.INDEX) {
                    //INDEX的情况
                    re += strArray[i] + index;
                } else {
                    //VALUE的情况
                    value = data;
                    each(tokenArray[i].split('.'), function (token) {
                        value = value[token];
                    });
                    if (value === undefined) {
                        value = '';
                    }
                    re += strArray[i] + value;
                }
            }

            re += strArray[i];
        } catch (e) {
            self.system.console.error(e);
        }

        return re;
    };

    /**
     * 生成rxId
     *
     * 根据HTML顺序的从上到下，父子关系的从外到内，以及从元素到属性的方向，rxId依次递减。
     * 换句话说，渲染RelaxTag时，只要遵循rxId从大到小的顺序，就不会出现遗漏和父未生成却要生成子的矛盾。
     */
    Relax.prototype.generateRxId = function() {
        var self = this;

        return self.container + ID_SPLITTER + (self.system.nodeLength++);
    };
    
    /**
     * 通过rxId获取analysed object
     *
     * @param {String} rxId
     */
    Relax.prototype.getTheAnaObj = function(rxId) {
        var self = this,
            path;

        if (rxId === '') {
            return self.analysed;
        } else {
            path = self.rxIdDetail[rxId].path;
        }

        return self.getAnaObjFromPath(path);
    };
                    
    /**
     * 通过path找到obj
     *
     * @param {String} path
     */
    Relax.prototype.getAnaObjFromPath = function(path) {
        var self = this,
            re = {};

        each(path.split(LEVEL_SPLITTER), function(one) {
            if (one === '') {
                re = self.analysed;
            }  else if (one === ATTR_SPLITTER) {
                re = re.attrs.special;
            } else if (one === VALUE_SPLITTER) {
                re = re.value;
            } else {
                if (re.children) {
                    re = re.children[one];
                } else {
                    re = re[one];
                }
            }
        });

        return re;
    };

    /**
     * 通过path找到属性的analysed object
     *
     * @param {String} path
     */
    Relax.prototype.getAttObjFromPath = function(path) {
        var self = this,
            node,
            attr;

        node = path.split(LEVEL_SPLITTER + ATTR_SPLITTER);
        attr = node[1];
        node = node[0];
        attr = attr.split(LEVEL_SPLITTER + VALUE_SPLITTER)[0];
        node = self.getAnaObjFromPath(node);
        each(attr.split(LEVEL_SPLITTER), function(one) {
            if (one === '') {
                attr = node.attrs.special;
            } else {
                attr = attr[one];
            }
        });

        return attr;
    };

    /**
     * Relax所有实例的集合。
     * 后期你可以通过container的ID从这里找到它们。
     */
    Relax.modules = {};

    /**
     * 复用DOM元素
     */
    Relax.reuseNode = {};

    /**
     * 准备执行的DOM操作
     */
    Relax.queue = [];

    /**
     * RelaxMap的构造函数，用于建立rxId与value的对应关系
     *
     * @param {Array} analysed
     * @param {Object} rxIdDetail
     */
    function RelaxMap(analysed, rxIdDetail) {
        var self = this;

        self.analysed = analysed;
        self.rxIdDetail = rxIdDetail;

        self.init();
    }

    /**
     * RelaxMap的初始化函数
     */
    RelaxMap.prototype.init = function() {
        var self = this;

        /**
         * rxId2value = {//MAP_B
         *    'id:2': [
         *       {
         *          value: '-a-b[*]-c',
         *          [listen: true]
         *       }
         *    ]
         * };
         */
        self.rxId2value = {};

        /**
         * value2rxId = {//MAP_A
         *    '-a-b-*-c': [
         *       {
         *          rxId: 'id:2'
         *       }
         *    ]
         * };
         */
        self.value2rxId = {};
    };

    /**
     * 向Map添加内容
     *
     * @param {String} rxId
     * @param {String} value
     * @param {Boolean} [valueIsListen]
     */
    RelaxMap.prototype.add = function(rxId, value, valueIsListen) {
        var self = this,
            rxIdTemp;

        //先删除，但这是一种肮脏的做法，最好严谨一些，不出现需要先删除的情况
        //self.removeRxId(rxId, value);
        //self.removeValue(value, rxId);

        if (!self.rxId2value[rxId]) {
            self.rxId2value[rxId] = [];
        }
        if (!self.value2rxId[value]) {
            self.value2rxId[value] = [];
        }

        rxIdTemp = {
            value: value
        };

        if (valueIsListen === true) {
            rxIdTemp.listen = true;
        }

        self.rxId2value[rxId].push(rxIdTemp);

        self.value2rxId[value].push({
            rxId: rxId
        });
    };

    /**
     * 删除的对称函数
     *
     * @param {String} a
     * @param {String|undefined} b
     * @param {String} A
     * @param {String} B
     *
     * 比如，删除value，限定rxId        value, rxId
     */
    RelaxMap.prototype._remove = function(a, b, A, B) {
        var self = this,
            MAP_A = A + '2' + B,//value2rxId
            MAP_B = B + '2' + A;//rxId2value

        //从这个rxId里删
        function from(b) {
            if (self[MAP_B][b]) {
                for (var i = 0, maxi = self[MAP_B][b].length; i < maxi; i++) {
                    if (self[MAP_B][b][i][A] === a) {
                        break;
                    }
                }
                self[MAP_B][b].splice(i, 1);

                if (self[MAP_B][b].length == 0) {
                    delete self[MAP_B][b];
                }
            }
            if (self[MAP_A][a]) {
                for (var i = 0, maxi = self[MAP_A][a].length; i < maxi; i++) {
                    if (self[MAP_A][a][i][B] === b) {
                        break;
                    }
                }
                self[MAP_A][a].splice(i, 1);

                if (self[MAP_A][a].length == 0) {
                    delete self[MAP_A][a];
                }
            }
        }

        if (b !== undefined) {
            from(b);
        } else {
            //首先看看这个value用了哪些rxId
            if (self[MAP_A][a]) {
                while(self[MAP_A][a] && self[MAP_A][a].length) {
                    from(self[MAP_A][a][0][B]);
                }
            }
        }
    };

    /**
     * 删除rxId
     *
     * @param {String} rxId
     * @param {String} [value] 表示只删除用了此value里的rxId
     */
    RelaxMap.prototype.removeRxId = function(rxId, value) {
        var self = this;

        self._remove(rxId, value, 'rxId', 'value');

        /**
         * 为了防止重复添加而进行的删除是不需要把该rxId都删干净的
         */
        /*if (value === undefined) {
            each(Object.keys(self.rxId2value), function(one) {
                if (one.length > rxId.length && one.indexOf(rxId) === 0) {
                    self._remove(one, undefined, 'rxId', 'value');
                }
            });
        }*/
    };

    /**
     * 删除value
     *
     * @param {String} value
     * @param {String} [rxId] 表示只删除在此rxId里出现的value
     */
    /*RelaxMap.prototype.removeValue = function(value, rxId) {
        var self = this;

        self._remove(value, rxId, 'value', 'rxId');
    };*/

    /**
     * 根据rxId从Map获取value
     *
     * @param {String} rxId
     */
    RelaxMap.prototype.getValueByRxId = function(rxId) {
        var self = this;

        return self.rxId2value[rxId];
    };

    /**
     * 根据value从Map获取rxId
     *
     * @param {String} value
     */
    RelaxMap.prototype.getRxIdByValue = function(value) {
        var self = this;

        return self.value2rxId[value];
    };

    /**
     * RelaxCache的构造函数，用于缓存生成结果或数据
     *
     * @param {Number} max
     * @param {Object} system
     * @param {Function} minifier
     */
    function RelaxCache(max, system, minifier) {
        var self = this;

        self.cacheCon = {};
        self.cacheKey = [];
        self.max = max;
        self.size = 0;
        self.cacheCleaned = 0;
        self.system = system;
        self.minifier = minifier;
    }

    /**
     * 增加或修改缓存
     *
     * @param {String} key
     * @param {String|Number} value
     */
    RelaxCache.prototype.set = function(key, value) {
        var self = this,
            newSize,
            originalKey,
            minifiedKey;

        originalKey = key.toString();

        if (self.minifier) {
            minifiedKey = self.minifier(originalKey);
        } else {
            minifiedKey = originalKey;
        }

        if (value === undefined) {
            self.del(originalKey);
            return;
        }

        value = value.toString();

        self.del(originalKey);

        if (notEnough()) {
            self.cacheCleaned++;
            if (self.cacheCleaned > CACHE_CALLED) {
                self.cacheCleaned = 0;
                self.system.console.info(self.system.logHead, 'Cache clean called for', newSize + ', your current cacheMax is', self.max);
            }
            while(notEnough()) {
                self.del(self.cacheKey.slice(-1)[0]);
            }
        }

        newSize = self.size + minifiedKey.length + value.length;

        self.size = newSize;

        self.cacheKey.unshift(minifiedKey);
        self.cacheCon[minifiedKey] = value;

        function notEnough() {
            return self.cacheKey.length && (newSize = self.size + minifiedKey.length + value.length) > self.max;
        }
    };

    /**
     * 获取缓存
     *
     * @param {String} key
     */
    RelaxCache.prototype.get = function(key) {
        var self = this,
            minifiedKey;

        if (self.minifier) {
            minifiedKey = self.minifier(key.toString());
        } else {
            minifiedKey = key.toString();
        }

        return self.cacheCon[minifiedKey];
    };

    /**
     * 删除缓存
     *
     * @param {String} key
     */
    RelaxCache.prototype.del = function(key) {
        var self = this,
            minifiedKey,
            index,
            deleted;

        if (self.minifier) {
            minifiedKey = self.minifier(key.toString());
        } else {
            minifiedKey = key.toString();
        }

        index = self.cacheKey.indexOf(minifiedKey);

        if (index != -1) {
            deleted = self.cacheCon[minifiedKey].length;
            delete self.cacheCon[minifiedKey];
            self.cacheKey.splice(index, 1);
            self.size -= minifiedKey.length + deleted;
        }
    };

    /**
     * 修改缓存同时判断这次是否和之前不同
     *
     * @param {String} key
     * @param {String|Number} value
     */
    RelaxCache.prototype.changed = function(key, value) {
        var self = this,
            re;

        re = value != self.get(key);
        self.set(key, value);

        return re;
    };

    /**
     * 对console的兼容性处理
     */
    if (window.console) {
        CONSOLE = window.console;
        if (window.console.time === undefined) {
            CONSOLE.time = fNOP;
            CONSOLE.timeEnd = fNOP;
        }
    } else {
        CONSOLE = {
            info   : fNOP,
            log    : fNOP,
            time   : fNOP,
            timeEnd: fNOP,
            error  : function() {
                alert(Array.prototype.slice.call(arguments).join(' '));
            }
        };
    }

    /**
     * 准备将要用到的DOM元素
     */
    Relax.reuseNode['div'] = document.createElement('div');
    Relax.reuseNode['frag'] = [];

    for (var key in TABLE_TAGS) {
        if (isOwnProp(TABLE_TAGS, key) && !Relax.reuseNode[TABLE_TAGS[key]]) {
            Relax.reuseNode[TABLE_TAGS[key]] = document.createElement(TABLE_TAGS[key]);
        }
    }

    function cleanDomChild(dom) {
        while (dom.lastChild) {
            dom.removeChild(dom.lastChild);
        }
    }

    IGNOREBLANK = (function() {
        var ignore;

        Relax.reuseNode['div'].innerHTML = ' ';

        ignore = Relax.reuseNode['div'].childNodes[0] == undefined;

        cleanDomChild(Relax.reuseNode['div']);

        return ignore;
    })();

    /**
     * 增加LOOP_SPLITTER的ALL和test
     */
    LOOP_SPLITTER.ALL = LOOP_SPLITTER.START + LOOP_SPLITTER.MIDDLE + LOOP_SPLITTER.END;
    LOOP_SPLITTER.test = new RegExp([
        '\\',
        LOOP_SPLITTER.START,
        '(\\d+)',
        '\\',
        LOOP_SPLITTER.END
    ].join(''), 'g');

    /**
     * 将含有数组的路径拆分
     */
    function splitLoop(string) {
        string = string.split(LOOP_SPLITTER.START);
        if (string.length > 1) {
            string = [
                string.slice(0, -1).join(LOOP_SPLITTER.START),
                parseInt(string.slice(-1)[0])
            ];
        } else {
            string = undefined;
        }
        return string;
    }

    /**
     * 格式化事件的名字
     */
    function normalizeEventName(name) {
        var splited = name.split(ID_SPLITTER);

        if (splited.length > 1) {
            if (splited[1].toLowerCase() === 'document') {
                splited[1] = 'document';
            }
            name = splited[0].toLowerCase() + ID_SPLITTER + splited[1];
        } else {
            name = splited[0].toLowerCase();
        }

        return name;
    }

    /**
     * domReady
     */
    function initDomReady() {
        var isPageLoaded = false,
            readyCalls = [],
            isTop,
            testDiv,
            scrollIntervalId;

        function callReady() {
            if (isPageLoaded) {
                while(readyCalls.length) {
                    readyCalls.shift()();
                }
            }
        }

        function pageLoaded() {
            if (!isPageLoaded) {
                isPageLoaded = true;

                if (document.addEventListener) {
                    document.removeEventListener("DOMContentLoaded", pageLoaded, false);
                    window.removeEventListener("load", pageLoaded, false);
                } else if (window.attachEvent) {
                    window.detachEvent("onload", pageLoaded);

                    if (scrollIntervalId) {
                        clearInterval(scrollIntervalId);
                    }
                }

                callReady();
            }
        }

        if (document.addEventListener) {
            document.addEventListener("DOMContentLoaded", pageLoaded, false);
            window.addEventListener("load", pageLoaded, false);
        } else if (window.attachEvent) {
            window.attachEvent("onload", pageLoaded);

            testDiv = document.createElement('div');

            try {
                isTop = window.frameElement === null;
            } catch (e) {
            }

            if (testDiv.doScroll && isTop && window.external) {
                scrollIntervalId = setInterval(function() {
                    try {
                        testDiv.doScroll();
                        pageLoaded();
                    } catch (e) {
                    }
                }, 30);
            }
        }

        if (document.readyState === "complete") {
            pageLoaded();
        }

        domReady = function (callback) {
            if (isPageLoaded) {
                callback();
            } else {
                readyCalls.push(callback);
            }
        };
    }

    function domReady(callback) {}

    initDomReady();

    /**
     * 事件的兼容性处理
     */
    function initEvents() {
        var listeners = {};

        function getUid(element) {
            var re;

            if (element === document) {
                re = 'document';
            } else {
                re = element.id;
            }

            return re;
        }

        function getSelf(containerId) {
            return Relax.modules[containerId];
        }

        function createWraped(containerId, handler) {
            return function (e) {
                var stopPropagation;

                e = e || window.event;

                stopPropagation = e.stopPropagation;

                e.stopPropagation = function() {
                    stopPropagation && stopPropagation.call(e);
                    e.cancelBubble = true;
                };

                if (e.preventDefault === undefined) {
                    e.preventDefault = function() {
                        e.returnValue = false;
                    };
                }
                /**
                 * 将this绑定到Relax实例
                 * 从保存的元素哈希表中取元素
                 * 处理好事件的取消冒泡和阻止默认行为
                 */
                handler.call(getSelf(containerId), e);
            };
        }

        function createListener(containerId, handler) {
            return {
                origin: handler,
                wrapped: createWraped(containerId, handler)
            };
        }

        function wrapHandler(containerId, element, eventName, handler) {
            var uid = getUid(element),
                listener;

            if (uid) {
                if (!listeners[uid]) {
                    listeners[uid] = {
                        allEvents: []
                    };
                }
                if (!listeners[uid][eventName]) {
                    listeners[uid].allEvents.push(eventName);
                    listeners[uid][eventName] = [];
                }

                listener = createListener(containerId, handler);
                listeners[uid][eventName].push(listener);

                return listener.wrapped;
            }
        }

        function getWrapHandler(element, eventName, handler) {
            var uid = getUid(element),
                handlers,
                list = [];

            if (uid && listeners[uid] && listeners[uid][eventName]) {
                handlers = listeners[uid][eventName];
                for (var i = 0, max = handlers.length; i < max; i++) {
                    if (handlers[i].origin === handler) {
                        list.push(handlers[i].wrapped);
                        handlers.splice(i, 1);
                        i--;
                        max--;
                    }
                }
                if (!handlers.length) {
                    delete listeners[uid][eventName];
                    listeners[uid].allEvents.splice(
                        listeners[uid].allEvents.indexOf(eventName),
                        1
                    );
                }
                if (!listeners[uid].allEvents.length) {
                    delete listeners[uid];
                }
            }

            return list;
        }

        if (document.addEventListener) {
            addListener = function (containerId, element, eventName, handler) {
                var wrapped = wrapHandler(containerId, element, eventName, handler);

                if (wrapped) {
                    element.addEventListener(eventName, wrapped, false);
                }
            };

            removeListener = function (containerId, element, eventName, handler) {
                each(getWrapHandler(containerId, element, eventName, handler), function(wrapped) {
                    element.removeEventListener(eventName, wrapped, false);
                });
            };
        } else {
            addListener = function (containerId, element, eventName, handler) {
                var wrapped = wrapHandler(containerId, element, eventName, handler);

                if (wrapped) {
                    element.attachEvent('on' + eventName, wrapped);
                }
            };

            removeListener = function (containerId, element, eventName, handler) {
                each(getWrapHandler(containerId, element, eventName, handler), function(wrapped) {
                    element.detachEvent('on' + eventName, wrapped);
                });
            };
        }
    }

    function addListener(containerId, element, eventName, handler) {}
    function removeListener(containerId, element, eventName, handler) {}

    initEvents();

    /**
     * 不能没有indexOf
     */
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function(elt) {
            var len = this.length >>> 0,
                from = Number(arguments[1]) || 0;

            from = (from < 0) ? Math.ceil(from) : Math.floor(from);

            if (from < 0)
                from += len;

            for (; from < len; from++) {
                if (from in this && this[from] === elt)
                    return from;
            }

            return -1;
        };
    }

    /**
     * 不能没有lastIndexOf
     */
    if (!Array.prototype.lastIndexOf) {
        Array.prototype.lastIndexOf = function(searchElement /*, fromIndex*/) {
            var n, k,
                t = Object(this),
                len = t.length >>> 0;

            if (len === 0) {
                return -1;
            }

            n = len - 1;

            if (arguments.length > 1) {
                n = Number(arguments[1]);
                if (n != n) {
                    n = 0;
                }
                else if (n != 0 && n != (1 / 0) && n != -(1 / 0)) {
                    n = (n > 0 || -1) * Math.floor(Math.abs(n));
                }
            }

            for (k = n >= 0 ? Math.min(n, len - 1) : len - Math.abs(n); k >= 0; k--) {
                if (k in t && t[k] === searchElement) {
                    return k;
                }
            }

            return -1;
        };
    }

    /**
     * 不能没有bind
     */
    if (!Function.prototype.bind) {
        Function.prototype.bind = function(oThis) {
            if (typeof this !== "function") {
                // closest thing possible to the ECMAScript 5 internal IsCallable function
                throw new TypeError("Function.prototype.bind - what is trying to be bound is not callable");
            }

            var aArgs = Array.prototype.slice.call(arguments, 1),
                fToBind = this,
                fNOP = function() {
                },
                fBound = function() {
                    return fToBind.apply(this instanceof fNOP && oThis ? this : oThis,
                        aArgs.concat(Array.prototype.slice.call(arguments)));
                };

            fNOP.prototype = this.prototype;
            fBound.prototype = new fNOP();

            return fBound;
        };
    }

    /**
     * 不能没有Object.keys
     */
    if (!Object.keys) {
        Object.keys = function(o) {
            var k=[],
                p;

            if (o !== Object(o)) {
                throw new TypeError('Object.keys called on a non-object');
            }

            for (p in o) {
                if (Object.prototype.hasOwnProperty.call(o,p)) {
                    k.push(p);
                }
            }

            return k;
        }
    }

    /**
     * 不能没有String.trim
     */
    if(!String.prototype.trim) {
        String.prototype.trim = function () {
            return this.replace(/^\s+|\s+$/g,'');
        };
    }

    /**
     * 空函数
     */
    function fNOP() {}

    /**
     * 不能没有each
     *
     * @param {Array} array
     * @param {Function} callback
     */
    function each(array, callback) {
        for (var i = 0, maxi = array.length; i < maxi; i++) {
            callback(array[i], i);
        }
    }

    /**
     * 类型判断
     *
     * @param {Object} obj
     */
    function kindOf(obj) {
        return Object.prototype.toString.call(obj);
    }

    /**
     * 检查某属性是否是自有属性
     *
     * @param {Object} obj
     * @param {String} attr
     */
    function isOwnProp(obj, attr) {
        return obj.hasOwnProperty(attr);
    }

    /**
     * 对象的克隆
     *
     * @param {Object} obj
     */
    function clone(obj) {
        var re;

        if (obj == null || typeof obj != "object") {
            return obj;
        } else if (obj instanceof Date) {
            re = new Date();
            re.setTime(obj.getTime());
            return re;
        } else if (obj instanceof Array) {
            re = [];
            for (var i = 0, len = obj.length; i < len; i++) {
                re[i] = clone(obj[i]);
            }
            return re;
        } else if (obj instanceof Object) {
            re = {};
            for (var attr in obj) {
                if (isOwnProp(obj, attr)) {
                    re[attr] = clone(obj[attr]);
                }
            }
            return re;
        }
    }

    /**
     * 对象的合并
     * 如果遇到同名属性(只限第一级)，obj2会覆盖obj1
     *
     * @param {Object} obj1
     * @param {Object} obj2
     */
    function merge(obj1, obj2) {
        var result = clone(obj1) || {};

        for (var attr in obj2) {
            if (isOwnProp(obj2, attr)) {
                result[attr] = clone(obj2[attr]);
            }
        }
        return result;
    }

    return Relax;
});